/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Money: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type ActiveOrderInput = {
  orderCode?: InputMaybe<OrderCodeActiveOrderInput>;
};

export type ActiveOrderResult = NoActiveOrderError | Order;

export type AddCompanyAddressResult = CompanyAddress | EntityNotFoundError;

export type AddDocumentToOrderInput = {
  name: Scalars['String']['input'];
  orderId: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type AddDocumentToOrderResult = EntityNotFoundError | OrderDocument;

export type AddItemToOrderBySkuInput = {
  quantity?: InputMaybe<Scalars['Int']['input']>;
  sku: Scalars['String']['input'];
};

export type AddItemToOrderBySkuResult = EntityNotFoundError | Order;

export type AddMultipleItemsToOrderResult = EntityNotFoundError | Order;

export type AddPaymentToOrderResult = IneligiblePaymentMethodError | NoActiveOrderError | Order | OrderPaymentStateError | OrderStateTransitionError | PaymentDeclinedError | PaymentFailedError;

export type Address = Node & {
  __typename?: 'Address';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country: Country;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  defaultBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  defaultShippingAddress?: Maybe<Scalars['Boolean']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  streetLine1: Scalars['String']['output'];
  streetLine2?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Adjustment = {
  __typename?: 'Adjustment';
  adjustmentSource: Scalars['String']['output'];
  amount: Scalars['Money']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  type: AdjustmentType;
};

export enum AdjustmentType {
  DistributedOrderPromotion = 'DISTRIBUTED_ORDER_PROMOTION',
  Other = 'OTHER',
  Promotion = 'PROMOTION'
}

/** Returned when attempting to set the Customer for an Order when already logged in. */
export type AlreadyLoggedInError = ErrorResult & {
  __typename?: 'AlreadyLoggedInError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type ApplyCouponCodeResult = CouponCodeExpiredError | CouponCodeInvalidError | CouponCodeLimitError | Order;

export type Asset = Node & {
  __typename?: 'Asset';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<AssetCustomFields>;
  fileSize: Scalars['Int']['output'];
  focalPoint?: Maybe<Coordinate>;
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  preview: Scalars['String']['output'];
  source: Scalars['String']['output'];
  tags: Array<Tag>;
  type: AssetType;
  updatedAt: Scalars['DateTime']['output'];
  width: Scalars['Int']['output'];
};

export type AssetCustomFields = {
  __typename?: 'AssetCustomFields';
  company?: Maybe<Company>;
  fileName?: Maybe<Scalars['String']['output']>;
  pimcoreId?: Maybe<Scalars['Int']['output']>;
};

export type AssetList = PaginatedList & {
  __typename?: 'AssetList';
  items: Array<Asset>;
  totalItems: Scalars['Int']['output'];
};

export enum AssetType {
  Binary = 'BINARY',
  Image = 'IMAGE',
  Video = 'VIDEO'
}

export type AssignContactPersonToCompaniesInput = {
  companyDebitorNumbersAndRoles: Array<CompanyDebitorsNumbersAndRolesInput>;
  contactPersonEmail: Scalars['String']['input'];
};

export type AssignContactPersonToCompaniesResult = ContactPerson | EntityNotFoundError;

export type AuthenticationInput = {
  native?: InputMaybe<NativeAuthInput>;
};

export type AuthenticationMethod = Node & {
  __typename?: 'AuthenticationMethod';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  strategy: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AuthenticationResult = CurrentUser | InvalidCredentialsError | NotVerifiedError;

export type B2BRegisterInput = {
  company?: InputMaybe<RegisterCompanyInput>;
  customer: RegisterCustomerInput;
};

export type Block = Node & {
  __typename?: 'Block';
  id: Scalars['ID']['output'];
  itemHeadline?: Maybe<Scalars['String']['output']>;
  itemText?: Maybe<Scalars['String']['output']>;
};

export type BooleanCustomFieldConfig = CustomField & {
  __typename?: 'BooleanCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/** Operators for filtering on a list of Boolean fields */
export type BooleanListOperators = {
  inList: Scalars['Boolean']['input'];
};

/** Operators for filtering on a Boolean field */
export type BooleanOperators = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BooleanStructFieldConfig = StructField & {
  __typename?: 'BooleanStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type Channel = Node & {
  __typename?: 'Channel';
  availableCurrencyCodes: Array<CurrencyCode>;
  availableLanguageCodes?: Maybe<Array<LanguageCode>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  /** @deprecated Use defaultCurrencyCode instead */
  currencyCode: CurrencyCode;
  customFields?: Maybe<Scalars['JSON']['output']>;
  defaultCurrencyCode: CurrencyCode;
  defaultLanguageCode: LanguageCode;
  defaultShippingZone?: Maybe<Zone>;
  defaultTaxZone?: Maybe<Zone>;
  id: Scalars['ID']['output'];
  /** Not yet used - will be implemented in a future release. */
  outOfStockThreshold?: Maybe<Scalars['Int']['output']>;
  pricesIncludeTax: Scalars['Boolean']['output'];
  seller?: Maybe<Seller>;
  token: Scalars['String']['output'];
  /** Not yet used - will be implemented in a future release. */
  trackInventory?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type Collection = Node & {
  __typename?: 'Collection';
  assets: Array<Asset>;
  breadcrumbs: Array<CollectionBreadcrumb>;
  children?: Maybe<Array<Collection>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<CollectionCustomFields>;
  description: Scalars['String']['output'];
  featuredAsset?: Maybe<Asset>;
  filters: Array<ConfigurableOperation>;
  id: Scalars['ID']['output'];
  languageCode?: Maybe<LanguageCode>;
  name: Scalars['String']['output'];
  parent?: Maybe<Collection>;
  parentId: Scalars['ID']['output'];
  position: Scalars['Int']['output'];
  productVariants: ProductVariantList;
  slug: Scalars['String']['output'];
  translations: Array<CollectionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CollectionProductVariantsArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
};

export type CollectionBreadcrumb = {
  __typename?: 'CollectionBreadcrumb';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type CollectionCustomFields = {
  __typename?: 'CollectionCustomFields';
  breadcrumbs?: Maybe<Scalars['String']['output']>;
  hasDetailPage?: Maybe<Scalars['Boolean']['output']>;
  pimcoreId?: Maybe<Scalars['Int']['output']>;
  preselectedDiameter?: Maybe<Scalars['Int']['output']>;
  seoDescription?: Maybe<Scalars['String']['output']>;
};

export type CollectionFilterParameter = {
  _and?: InputMaybe<Array<CollectionFilterParameter>>;
  _or?: InputMaybe<Array<CollectionFilterParameter>>;
  breadcrumbs?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  hasDetailPage?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  parentId?: InputMaybe<IdOperators>;
  pimcoreId?: InputMaybe<NumberOperators>;
  position?: InputMaybe<NumberOperators>;
  preselectedDiameter?: InputMaybe<NumberOperators>;
  seoDescription?: InputMaybe<StringOperators>;
  slug?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type CollectionList = PaginatedList & {
  __typename?: 'CollectionList';
  items: Array<Collection>;
  totalItems: Scalars['Int']['output'];
};

export type CollectionListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CollectionFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CollectionSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
  topLevelOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Which Collections are present in the products returned
 * by the search, and in what quantity.
 */
export type CollectionResult = {
  __typename?: 'CollectionResult';
  collection: Collection;
  count: Scalars['Int']['output'];
};

export type CollectionSortParameter = {
  breadcrumbs?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  hasDetailPage?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  parentId?: InputMaybe<SortOrder>;
  pimcoreId?: InputMaybe<SortOrder>;
  position?: InputMaybe<SortOrder>;
  preselectedDiameter?: InputMaybe<SortOrder>;
  seoDescription?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type CollectionTranslation = {
  __typename?: 'CollectionTranslation';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<CollectionTranslationCustomFields>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CollectionTranslationCustomFields = {
  __typename?: 'CollectionTranslationCustomFields';
  seoDescription?: Maybe<Scalars['String']['output']>;
};

export type Company = Node & {
  __typename?: 'Company';
  addresses: Array<CompanyAddress>;
  availableRoles?: Maybe<Array<Maybe<CompanyRole>>>;
  contactPersonCompanies: Array<Maybe<ContactPersonCompany>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<CompanyCustomFields>;
  customers?: Maybe<CustomerList>;
  discounts?: Maybe<Array<Maybe<CustomerDiscount>>>;
  employments?: Maybe<Array<Maybe<Employment>>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  organization?: Maybe<Organization>;
  status: CompanyStatus;
  termsOfPayment?: Maybe<TermsOfPayment>;
  updatedAt: Scalars['DateTime']['output'];
};


export type CompanyCustomersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};

export type CompanyAddress = Node & {
  __typename?: 'CompanyAddress';
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<CompanyAddressCustomFields>;
  defaultBillingAddress: Scalars['Boolean']['output'];
  defaultShippingAddress: Scalars['Boolean']['output'];
  fullName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  streetLine1: Scalars['String']['output'];
  streetLine2?: Maybe<Scalars['String']['output']>;
};

export type CompanyAddressCustomFields = {
  __typename?: 'CompanyAddressCustomFields';
  erpId?: Maybe<Scalars['String']['output']>;
};

export type CompanyCustomFields = {
  __typename?: 'CompanyCustomFields';
  erpId?: Maybe<Scalars['String']['output']>;
  isConfiguratorAdmin?: Maybe<Scalars['Boolean']['output']>;
  ust?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type CompanyCustomersResult = CustomerList | EntityNotFoundError | UnauthorizedError;

export type CompanyDebitorsNumbersAndRolesInput = {
  debitorNumber: Scalars['String']['input'];
  role: ContactPersonRoles;
};

export type CompanyFilterParameter = {
  _and?: InputMaybe<Array<CompanyFilterParameter>>;
  _or?: InputMaybe<Array<CompanyFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  erpId?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  isConfiguratorAdmin?: InputMaybe<BooleanOperators>;
  name?: InputMaybe<StringOperators>;
  status?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  ust?: InputMaybe<StringOperators>;
  vat?: InputMaybe<StringOperators>;
};

export type CompanyList = PaginatedList & {
  __typename?: 'CompanyList';
  items: Array<Company>;
  totalItems: Scalars['Int']['output'];
};

export type CompanyListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CompanyFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CompanySortParameter>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyRole = Node & {
  __typename?: 'CompanyRole';
  company: Company;
  id: Scalars['ID']['output'];
  isCompanyAgnostic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CompanyRoleList = PaginatedList & {
  __typename?: 'CompanyRoleList';
  items: Array<CompanyRole>;
  totalItems: Scalars['Int']['output'];
};

export type CompanyRoleListOptions = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanyRoleResult = CompanyRole | EntityNotFoundError;

export type CompanySortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  erpId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isConfiguratorAdmin?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  ust?: InputMaybe<SortOrder>;
  vat?: InputMaybe<SortOrder>;
};

export enum CompanyStatus {
  Approved = 'Approved',
  InReview = 'InReview',
  Rejected = 'Rejected'
}

export type ConfigArg = {
  __typename?: 'ConfigArg';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ConfigArgDefinition = {
  __typename?: 'ConfigArgDefinition';
  defaultValue?: Maybe<Scalars['JSON']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  required: Scalars['Boolean']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type ConfigArgInput = {
  name: Scalars['String']['input'];
  /** A JSON stringified representation of the actual value */
  value: Scalars['String']['input'];
};

export type ConfigurableOperation = {
  __typename?: 'ConfigurableOperation';
  args: Array<ConfigArg>;
  code: Scalars['String']['output'];
};

export type ConfigurableOperationDefinition = {
  __typename?: 'ConfigurableOperationDefinition';
  args: Array<ConfigArgDefinition>;
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
};

export type ConfigurableOperationInput = {
  arguments: Array<ConfigArgInput>;
  code: Scalars['String']['input'];
};

export type ContactPerson = Node & {
  __typename?: 'ContactPerson';
  absent: Scalars['Boolean']['output'];
  absentFrom?: Maybe<Scalars['DateTime']['output']>;
  absentTo?: Maybe<Scalars['DateTime']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  contactPersonCompanies?: Maybe<Array<Maybe<ContactPersonCompany>>>;
  department?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  fax?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jobTitle?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  portrait?: Maybe<Scalars['String']['output']>;
  workHoursFrom?: Maybe<Scalars['String']['output']>;
  workHoursTo?: Maybe<Scalars['String']['output']>;
};

export type ContactPersonCompany = Node & {
  __typename?: 'ContactPersonCompany';
  company?: Maybe<Company>;
  contactPerson?: Maybe<ContactPerson>;
  id: Scalars['ID']['output'];
  role?: Maybe<ContactPersonRoles>;
};

export type ContactPersonList = PaginatedList & {
  __typename?: 'ContactPersonList';
  items: Array<ContactPerson>;
  totalItems: Scalars['Int']['output'];
};

export type ContactPersonListOptions = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContactPersonRoles {
  AccountManager = 'ACCOUNT_MANAGER',
  ApplicationEngineer = 'APPLICATION_ENGINEER',
  CustomerServiceOfficer = 'CUSTOMER_SERVICE_OFFICER',
  GroupAccountManager = 'GROUP_ACCOUNT_MANAGER'
}

export type Coordinate = {
  __typename?: 'Coordinate';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

/**
 * A Country of the world which your shop operates in.
 *
 * The `code` field is typically a 2-character ISO code such as "GB", "US", "DE" etc. This code is used in certain inputs such as
 * `UpdateAddressInput` and `CreateAddressInput` to specify the country.
 */
export type Country = Node & Region & {
  __typename?: 'Country';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CountryList = PaginatedList & {
  __typename?: 'CountryList';
  items: Array<Country>;
  totalItems: Scalars['Int']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeExpiredError = ErrorResult & {
  __typename?: 'CouponCodeExpiredError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeInvalidError = ErrorResult & {
  __typename?: 'CouponCodeInvalidError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned if the provided coupon code is invalid */
export type CouponCodeLimitError = ErrorResult & {
  __typename?: 'CouponCodeLimitError';
  couponCode: Scalars['String']['output'];
  errorCode: ErrorCode;
  limit: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

/**
 * Input used to create an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type CreateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetCustomFieldsInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  fileName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAssetInput = {
  customFields?: InputMaybe<CreateAssetCustomFieldsInput>;
  file: Scalars['Upload']['input'];
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCompanyAddressCustomFieldsInput = {
  erpId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode: Scalars['String']['input'];
  customFields?: InputMaybe<CreateCompanyAddressCustomFieldsInput>;
  fullName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1: Scalars['String']['input'];
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyCustomFieldsInput = {
  erpId?: InputMaybe<Scalars['String']['input']>;
  isConfiguratorAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  ust?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyInput = {
  customFields?: InputMaybe<CreateCompanyCustomFieldsInput>;
  name: Scalars['String']['input'];
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateCompanyResult = Company | InvalidVatError;

export type CreateCompanyRoleInput = {
  companyId: Scalars['ID']['input'];
  isCompanyAgnostic?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

export type CreateCompanyRoleResult = CompanyRole | EntityNotFoundError;

export type CreateContactPersonInput = {
  absent: Scalars['Boolean']['input'];
  absentFrom?: InputMaybe<Scalars['DateTime']['input']>;
  absentTo?: InputMaybe<Scalars['DateTime']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  portrait?: InputMaybe<Scalars['String']['input']>;
  workHoursFrom?: InputMaybe<Scalars['String']['input']>;
  workHoursTo?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactPersonResult = ContactPerson | EntityNotFoundError | NotAllowedError;

export type CreateCustomerCustomFieldsInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyRolesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCustomerInput = {
  customFields?: InputMaybe<CreateCustomerCustomFieldsInput>;
  emailAddress: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEmploymentInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyRoleId?: InputMaybe<Scalars['ID']['input']>;
  customerId: Scalars['ID']['input'];
};

export type CreateEmploymentResult = Employment | EntityNotFoundError;

export type CreateOfferInput = {
  additionalDiscount?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  date: Scalars['DateTime']['input'];
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['String']['input'];
  positions?: InputMaybe<Array<CreateOfferPositionInput>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OfferStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  termsOfDelivery?: InputMaybe<Scalars['String']['input']>;
  termsOfPayment?: InputMaybe<Scalars['String']['input']>;
};

export type CreateOfferPositionInput = {
  alternative: Scalars['Boolean']['input'];
  discount: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  positionTotal: Scalars['Int']['input'];
  price: Scalars['Int']['input'];
  productVariantId?: InputMaybe<Scalars['ID']['input']>;
  quantity: Scalars['Int']['input'];
  taxRate: Scalars['Int']['input'];
};

export type CreateOfferPriceInput = {
  currencyCode: Scalars['String']['input'];
  price: Scalars['Int']['input'];
  productVariantId: Scalars['ID']['input'];
};

export type CreateOfferPriceResult = EntityNotFoundError | OfferPrice;

export type CreateOfferPricesResult = EntityNotFoundError | OfferPriceList;

export type CreateOfferResult = CustomerInputEmptyError | CustomerInputExistsError | EntityNotFoundError | NotAllowedError | Offer;

export type CreateOrganizationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  name: Scalars['String']['input'];
};

export type CreateOrganizationResult = DuplicateEntityError | Organization;

export type CreateShopAssetResult = Asset | EntityNotFoundError | MimeTypeError | NotAllowedError;

export type CreateWishlistInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/**
 * @description
 * ISO 4217 currency code
 *
 * @docsCategory common
 */
export enum CurrencyCode {
  /** United Arab Emirates dirham */
  Aed = 'AED',
  /** Afghan afghani */
  Afn = 'AFN',
  /** Albanian lek */
  All = 'ALL',
  /** Armenian dram */
  Amd = 'AMD',
  /** Netherlands Antillean guilder */
  Ang = 'ANG',
  /** Angolan kwanza */
  Aoa = 'AOA',
  /** Argentine peso */
  Ars = 'ARS',
  /** Australian dollar */
  Aud = 'AUD',
  /** Aruban florin */
  Awg = 'AWG',
  /** Azerbaijani manat */
  Azn = 'AZN',
  /** Bosnia and Herzegovina convertible mark */
  Bam = 'BAM',
  /** Barbados dollar */
  Bbd = 'BBD',
  /** Bangladeshi taka */
  Bdt = 'BDT',
  /** Bulgarian lev */
  Bgn = 'BGN',
  /** Bahraini dinar */
  Bhd = 'BHD',
  /** Burundian franc */
  Bif = 'BIF',
  /** Bermudian dollar */
  Bmd = 'BMD',
  /** Brunei dollar */
  Bnd = 'BND',
  /** Boliviano */
  Bob = 'BOB',
  /** Brazilian real */
  Brl = 'BRL',
  /** Bahamian dollar */
  Bsd = 'BSD',
  /** Bhutanese ngultrum */
  Btn = 'BTN',
  /** Botswana pula */
  Bwp = 'BWP',
  /** Belarusian ruble */
  Byn = 'BYN',
  /** Belize dollar */
  Bzd = 'BZD',
  /** Canadian dollar */
  Cad = 'CAD',
  /** Congolese franc */
  Cdf = 'CDF',
  /** Swiss franc */
  Chf = 'CHF',
  /** Chilean peso */
  Clp = 'CLP',
  /** Renminbi (Chinese) yuan */
  Cny = 'CNY',
  /** Colombian peso */
  Cop = 'COP',
  /** Costa Rican colon */
  Crc = 'CRC',
  /** Cuban convertible peso */
  Cuc = 'CUC',
  /** Cuban peso */
  Cup = 'CUP',
  /** Cape Verde escudo */
  Cve = 'CVE',
  /** Czech koruna */
  Czk = 'CZK',
  /** Djiboutian franc */
  Djf = 'DJF',
  /** Danish krone */
  Dkk = 'DKK',
  /** Dominican peso */
  Dop = 'DOP',
  /** Algerian dinar */
  Dzd = 'DZD',
  /** Egyptian pound */
  Egp = 'EGP',
  /** Eritrean nakfa */
  Ern = 'ERN',
  /** Ethiopian birr */
  Etb = 'ETB',
  /** Euro */
  Eur = 'EUR',
  /** Fiji dollar */
  Fjd = 'FJD',
  /** Falkland Islands pound */
  Fkp = 'FKP',
  /** Pound sterling */
  Gbp = 'GBP',
  /** Georgian lari */
  Gel = 'GEL',
  /** Ghanaian cedi */
  Ghs = 'GHS',
  /** Gibraltar pound */
  Gip = 'GIP',
  /** Gambian dalasi */
  Gmd = 'GMD',
  /** Guinean franc */
  Gnf = 'GNF',
  /** Guatemalan quetzal */
  Gtq = 'GTQ',
  /** Guyanese dollar */
  Gyd = 'GYD',
  /** Hong Kong dollar */
  Hkd = 'HKD',
  /** Honduran lempira */
  Hnl = 'HNL',
  /** Croatian kuna */
  Hrk = 'HRK',
  /** Haitian gourde */
  Htg = 'HTG',
  /** Hungarian forint */
  Huf = 'HUF',
  /** Indonesian rupiah */
  Idr = 'IDR',
  /** Israeli new shekel */
  Ils = 'ILS',
  /** Indian rupee */
  Inr = 'INR',
  /** Iraqi dinar */
  Iqd = 'IQD',
  /** Iranian rial */
  Irr = 'IRR',
  /** Icelandic króna */
  Isk = 'ISK',
  /** Jamaican dollar */
  Jmd = 'JMD',
  /** Jordanian dinar */
  Jod = 'JOD',
  /** Japanese yen */
  Jpy = 'JPY',
  /** Kenyan shilling */
  Kes = 'KES',
  /** Kyrgyzstani som */
  Kgs = 'KGS',
  /** Cambodian riel */
  Khr = 'KHR',
  /** Comoro franc */
  Kmf = 'KMF',
  /** North Korean won */
  Kpw = 'KPW',
  /** South Korean won */
  Krw = 'KRW',
  /** Kuwaiti dinar */
  Kwd = 'KWD',
  /** Cayman Islands dollar */
  Kyd = 'KYD',
  /** Kazakhstani tenge */
  Kzt = 'KZT',
  /** Lao kip */
  Lak = 'LAK',
  /** Lebanese pound */
  Lbp = 'LBP',
  /** Sri Lankan rupee */
  Lkr = 'LKR',
  /** Liberian dollar */
  Lrd = 'LRD',
  /** Lesotho loti */
  Lsl = 'LSL',
  /** Libyan dinar */
  Lyd = 'LYD',
  /** Moroccan dirham */
  Mad = 'MAD',
  /** Moldovan leu */
  Mdl = 'MDL',
  /** Malagasy ariary */
  Mga = 'MGA',
  /** Macedonian denar */
  Mkd = 'MKD',
  /** Myanmar kyat */
  Mmk = 'MMK',
  /** Mongolian tögrög */
  Mnt = 'MNT',
  /** Macanese pataca */
  Mop = 'MOP',
  /** Mauritanian ouguiya */
  Mru = 'MRU',
  /** Mauritian rupee */
  Mur = 'MUR',
  /** Maldivian rufiyaa */
  Mvr = 'MVR',
  /** Malawian kwacha */
  Mwk = 'MWK',
  /** Mexican peso */
  Mxn = 'MXN',
  /** Malaysian ringgit */
  Myr = 'MYR',
  /** Mozambican metical */
  Mzn = 'MZN',
  /** Namibian dollar */
  Nad = 'NAD',
  /** Nigerian naira */
  Ngn = 'NGN',
  /** Nicaraguan córdoba */
  Nio = 'NIO',
  /** Norwegian krone */
  Nok = 'NOK',
  /** Nepalese rupee */
  Npr = 'NPR',
  /** New Zealand dollar */
  Nzd = 'NZD',
  /** Omani rial */
  Omr = 'OMR',
  /** Panamanian balboa */
  Pab = 'PAB',
  /** Peruvian sol */
  Pen = 'PEN',
  /** Papua New Guinean kina */
  Pgk = 'PGK',
  /** Philippine peso */
  Php = 'PHP',
  /** Pakistani rupee */
  Pkr = 'PKR',
  /** Polish złoty */
  Pln = 'PLN',
  /** Paraguayan guaraní */
  Pyg = 'PYG',
  /** Qatari riyal */
  Qar = 'QAR',
  /** Romanian leu */
  Ron = 'RON',
  /** Serbian dinar */
  Rsd = 'RSD',
  /** Russian ruble */
  Rub = 'RUB',
  /** Rwandan franc */
  Rwf = 'RWF',
  /** Saudi riyal */
  Sar = 'SAR',
  /** Solomon Islands dollar */
  Sbd = 'SBD',
  /** Seychelles rupee */
  Scr = 'SCR',
  /** Sudanese pound */
  Sdg = 'SDG',
  /** Swedish krona/kronor */
  Sek = 'SEK',
  /** Singapore dollar */
  Sgd = 'SGD',
  /** Saint Helena pound */
  Shp = 'SHP',
  /** Sierra Leonean leone */
  Sll = 'SLL',
  /** Somali shilling */
  Sos = 'SOS',
  /** Surinamese dollar */
  Srd = 'SRD',
  /** South Sudanese pound */
  Ssp = 'SSP',
  /** São Tomé and Príncipe dobra */
  Stn = 'STN',
  /** Salvadoran colón */
  Svc = 'SVC',
  /** Syrian pound */
  Syp = 'SYP',
  /** Swazi lilangeni */
  Szl = 'SZL',
  /** Thai baht */
  Thb = 'THB',
  /** Tajikistani somoni */
  Tjs = 'TJS',
  /** Turkmenistan manat */
  Tmt = 'TMT',
  /** Tunisian dinar */
  Tnd = 'TND',
  /** Tongan paʻanga */
  Top = 'TOP',
  /** Turkish lira */
  Try = 'TRY',
  /** Trinidad and Tobago dollar */
  Ttd = 'TTD',
  /** New Taiwan dollar */
  Twd = 'TWD',
  /** Tanzanian shilling */
  Tzs = 'TZS',
  /** Ukrainian hryvnia */
  Uah = 'UAH',
  /** Ugandan shilling */
  Ugx = 'UGX',
  /** United States dollar */
  Usd = 'USD',
  /** Uruguayan peso */
  Uyu = 'UYU',
  /** Uzbekistan som */
  Uzs = 'UZS',
  /** Venezuelan bolívar soberano */
  Ves = 'VES',
  /** Vietnamese đồng */
  Vnd = 'VND',
  /** Vanuatu vatu */
  Vuv = 'VUV',
  /** Samoan tala */
  Wst = 'WST',
  /** CFA franc BEAC */
  Xaf = 'XAF',
  /** East Caribbean dollar */
  Xcd = 'XCD',
  /** CFA franc BCEAO */
  Xof = 'XOF',
  /** CFP franc (franc Pacifique) */
  Xpf = 'XPF',
  /** Yemeni rial */
  Yer = 'YER',
  /** South African rand */
  Zar = 'ZAR',
  /** Zambian kwacha */
  Zmw = 'ZMW',
  /** Zimbabwean dollar */
  Zwl = 'ZWL'
}

export type CurrentUser = {
  __typename?: 'CurrentUser';
  channels: Array<CurrentUserChannel>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
};

export type CurrentUserChannel = {
  __typename?: 'CurrentUserChannel';
  code: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<Permission>;
  token: Scalars['String']['output'];
};

export type CustomField = {
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type CustomFieldConfig = BooleanCustomFieldConfig | DateTimeCustomFieldConfig | FloatCustomFieldConfig | IntCustomFieldConfig | LocaleStringCustomFieldConfig | LocaleTextCustomFieldConfig | RelationCustomFieldConfig | StringCustomFieldConfig | StructCustomFieldConfig | TextCustomFieldConfig;

export type Customer = Node & {
  __typename?: 'Customer';
  addresses?: Maybe<Array<Address>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<CustomerCustomFields>;
  emailAddress: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groups: Array<CustomerGroup>;
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  orders: OrderList;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  user?: Maybe<User>;
};


export type CustomerOrdersArgs = {
  options?: InputMaybe<OrderListOptions>;
};

export type CustomerCustomFields = {
  __typename?: 'CustomerCustomFields';
  company?: Maybe<Company>;
  companyRoles?: Maybe<Array<CompanyRole>>;
  employments?: Maybe<Array<Employment>>;
  erpId?: Maybe<Scalars['String']['output']>;
  pimcoreId?: Maybe<Scalars['Int']['output']>;
  salutation?: Maybe<Scalars['String']['output']>;
  useCSP?: Maybe<Scalars['Boolean']['output']>;
};

export type CustomerDiscount = Node & {
  __typename?: 'CustomerDiscount';
  customFields?: Maybe<CustomerDiscountCustomFields>;
  customerDiscountPercentages?: Maybe<Array<Maybe<CustomerDiscountPercentage>>>;
  discountGroup?: Maybe<Scalars['String']['output']>;
  discountType?: Maybe<Scalars['String']['output']>;
  discountType2?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  priceType?: Maybe<Scalars['String']['output']>;
};

export type CustomerDiscountCustomFields = {
  __typename?: 'CustomerDiscountCustomFields';
  erpId?: Maybe<Scalars['String']['output']>;
};

export type CustomerDiscountPercentage = Node & {
  __typename?: 'CustomerDiscountPercentage';
  id: Scalars['ID']['output'];
  index?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type CustomerFilterParameter = {
  _and?: InputMaybe<Array<CustomerFilterParameter>>;
  _or?: InputMaybe<Array<CustomerFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  emailAddress?: InputMaybe<StringOperators>;
  erpId?: InputMaybe<StringOperators>;
  firstName?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  lastName?: InputMaybe<StringOperators>;
  phoneNumber?: InputMaybe<StringOperators>;
  pimcoreId?: InputMaybe<NumberOperators>;
  salutation?: InputMaybe<StringOperators>;
  title?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
  useCSP?: InputMaybe<BooleanOperators>;
};

export type CustomerFoundError = ErrorResult & {
  __typename?: 'CustomerFoundError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type CustomerGroup = Node & {
  __typename?: 'CustomerGroup';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  customers: CustomerList;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};


export type CustomerGroupCustomersArgs = {
  options?: InputMaybe<CustomerListOptions>;
};

export type CustomerInputEmptyError = ErrorResult & {
  __typename?: 'CustomerInputEmptyError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type CustomerInputExistsError = ErrorResult & {
  __typename?: 'CustomerInputExistsError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type CustomerList = PaginatedList & {
  __typename?: 'CustomerList';
  items: Array<Customer>;
  totalItems: Scalars['Int']['output'];
};

export type CustomerListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<CustomerFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<CustomerSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type CustomerSortParameter = {
  company?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  emailAddress?: InputMaybe<SortOrder>;
  erpId?: InputMaybe<SortOrder>;
  firstName?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastName?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  pimcoreId?: InputMaybe<SortOrder>;
  salutation?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  useCSP?: InputMaybe<SortOrder>;
};

export type CustomerSpecificPrice = {
  __typename?: 'CustomerSpecificPrice';
  basePrice: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  priceIncludesTax: Scalars['Boolean']['output'];
};

/** Operators for filtering on a list of Date fields */
export type DateListOperators = {
  inList: Scalars['DateTime']['input'];
};

/** Operators for filtering on a DateTime field */
export type DateOperators = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  between?: InputMaybe<DateRange>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DateRange = {
  end: Scalars['DateTime']['input'];
  start: Scalars['DateTime']['input'];
};

/**
 * Expects the same validation formats as the `<input type="datetime-local">` HTML element.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#Additional_attributes
 */
export type DateTimeCustomFieldConfig = CustomField & {
  __typename?: 'DateTimeCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/**
 * Expects the same validation formats as the `<input type="datetime-local">` HTML element.
 * See https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#Additional_attributes
 */
export type DateTimeStructFieldConfig = StructField & {
  __typename?: 'DateTimeStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type DeleteCompanyAddressResult = EntityNotFoundError | Success;

export type DeleteCompanyResult = CustomerFoundError | DeleteResult | EntityNotFoundError;

export type DeleteCompanyRoleResult = EntityNotFoundError | Success;

export type DeleteContactPersonResult = EntityNotFoundError | Success;

export type DeleteEmploymentResult = EntityNotFoundError | Success;

export type DeleteOfferPriceResult = EntityNotFoundError | Success;

export type DeleteOfferResult = EntityNotFoundError | NotAllowedError | Success;

export type DeleteOrderDocumentResult = EntityNotFoundError | Success;

export type DeleteOrganizationResult = EntityNotFoundError | Success;

export type DeleteResult = {
  __typename?: 'DeleteResult';
  affected?: Maybe<Scalars['Int']['output']>;
};

export type DeletionResponse = {
  __typename?: 'DeletionResponse';
  message?: Maybe<Scalars['String']['output']>;
  result: DeletionResult;
};

export enum DeletionResult {
  /** The entity was successfully deleted */
  Deleted = 'DELETED',
  /** Deletion did not take place, reason given in message */
  NotDeleted = 'NOT_DELETED'
}

export type Discount = {
  __typename?: 'Discount';
  adjustmentSource: Scalars['String']['output'];
  amount: Scalars['Money']['output'];
  amountWithTax: Scalars['Money']['output'];
  description: Scalars['String']['output'];
  type: AdjustmentType;
};

export type Download = Node & {
  __typename?: 'Download';
  fileName: Scalars['String']['output'];
  fileSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type DuplicateEntityError = ErrorResult & {
  __typename?: 'DuplicateEntityError';
  duplicationError: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when attempting to create a Customer with an email address already registered to an existing User. */
export type EmailAddressConflictError = ErrorResult & {
  __typename?: 'EmailAddressConflictError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Employment = Node & {
  __typename?: 'Employment';
  company?: Maybe<Company>;
  companyRole?: Maybe<CompanyRole>;
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type EmploymentList = PaginatedList & {
  __typename?: 'EmploymentList';
  items: Array<Employment>;
  totalItems: Scalars['Int']['output'];
};

export type EmploymentListOptions = {
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type EmploymentResult = Employment | EntityNotFoundError;

export type EntityNotFoundError = ErrorResult & {
  __typename?: 'EntityNotFoundError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export enum ErrorCode {
  AlreadyLoggedInError = 'ALREADY_LOGGED_IN_ERROR',
  CouponCodeExpiredError = 'COUPON_CODE_EXPIRED_ERROR',
  CouponCodeInvalidError = 'COUPON_CODE_INVALID_ERROR',
  CouponCodeLimitError = 'COUPON_CODE_LIMIT_ERROR',
  CustomerFoundError = 'CUSTOMER_FOUND_ERROR',
  CustomerInputEmptyError = 'CUSTOMER_INPUT_EMPTY_ERROR',
  CustomerInputErrorEmpty = 'CUSTOMER_INPUT_ERROR_EMPTY',
  CustomerInputErrorExists = 'CUSTOMER_INPUT_ERROR_EXISTS',
  CustomerInputExistsError = 'CUSTOMER_INPUT_EXISTS_ERROR',
  DuplicateEntityError = 'DUPLICATE_ENTITY_ERROR',
  EmailAddressConflictError = 'EMAIL_ADDRESS_CONFLICT_ERROR',
  EntityNotFoundError = 'ENTITY_NOT_FOUND_ERROR',
  GuestCheckoutError = 'GUEST_CHECKOUT_ERROR',
  IdentifierChangeTokenExpiredError = 'IDENTIFIER_CHANGE_TOKEN_EXPIRED_ERROR',
  IdentifierChangeTokenInvalidError = 'IDENTIFIER_CHANGE_TOKEN_INVALID_ERROR',
  IneligiblePaymentMethodError = 'INELIGIBLE_PAYMENT_METHOD_ERROR',
  IneligibleShippingMethodError = 'INELIGIBLE_SHIPPING_METHOD_ERROR',
  InsufficientStockError = 'INSUFFICIENT_STOCK_ERROR',
  InvalidCredentialsError = 'INVALID_CREDENTIALS_ERROR',
  InvalidVatError = 'INVALID_VAT_ERROR',
  MimeTypeError = 'MIME_TYPE_ERROR',
  MissingPasswordError = 'MISSING_PASSWORD_ERROR',
  NativeAuthStrategyError = 'NATIVE_AUTH_STRATEGY_ERROR',
  NegativeQuantityError = 'NEGATIVE_QUANTITY_ERROR',
  NotAllowedError = 'NOT_ALLOWED_ERROR',
  NotVerifiedError = 'NOT_VERIFIED_ERROR',
  NoActiveOrderError = 'NO_ACTIVE_ORDER_ERROR',
  NoChannelForCountryCodeError = 'NO_CHANNEL_FOR_COUNTRY_CODE_ERROR',
  OrderInterceptorError = 'ORDER_INTERCEPTOR_ERROR',
  OrderLimitError = 'ORDER_LIMIT_ERROR',
  OrderModificationError = 'ORDER_MODIFICATION_ERROR',
  OrderPaymentStateError = 'ORDER_PAYMENT_STATE_ERROR',
  OrderStateTransitionError = 'ORDER_STATE_TRANSITION_ERROR',
  PasswordAlreadySetError = 'PASSWORD_ALREADY_SET_ERROR',
  PasswordResetTokenExpiredError = 'PASSWORD_RESET_TOKEN_EXPIRED_ERROR',
  PasswordResetTokenInvalidError = 'PASSWORD_RESET_TOKEN_INVALID_ERROR',
  PasswordValidationError = 'PASSWORD_VALIDATION_ERROR',
  PaymentDeclinedError = 'PAYMENT_DECLINED_ERROR',
  PaymentFailedError = 'PAYMENT_FAILED_ERROR',
  UnauthorizedError = 'UNAUTHORIZED_ERROR',
  UnknownError = 'UNKNOWN_ERROR',
  VerificationTokenExpiredError = 'VERIFICATION_TOKEN_EXPIRED_ERROR',
  VerificationTokenInvalidError = 'VERIFICATION_TOKEN_INVALID_ERROR'
}

export type ErrorResult = {
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Facet = Node & {
  __typename?: 'Facet';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<FacetTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  /** Returns a paginated, sortable, filterable list of the Facet's values. Added in v2.1.0. */
  valueList: FacetValueList;
  values: Array<FacetValue>;
};


export type FacetValueListArgs = {
  options?: InputMaybe<FacetValueListOptions>;
};

export type FacetCountData = {
  __typename?: 'FacetCountData';
  counts: Array<FacetCountItem>;
  fieldName: Scalars['String']['output'];
  stats?: Maybe<FacetCountStats>;
};

export type FacetCountItem = {
  __typename?: 'FacetCountItem';
  count: Scalars['Int']['output'];
  highlighted: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type FacetCountStats = {
  __typename?: 'FacetCountStats';
  avg: Scalars['Float']['output'];
  max: Scalars['Float']['output'];
  min: Scalars['Float']['output'];
  sum: Scalars['Float']['output'];
};

export type FacetFilter = {
  code: Scalars['String']['input'];
  facetValueCodes: Array<Scalars['String']['input']>;
};

export type FacetFilterParameter = {
  _and?: InputMaybe<Array<FacetFilterParameter>>;
  _or?: InputMaybe<Array<FacetFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FacetList = PaginatedList & {
  __typename?: 'FacetList';
  items: Array<Facet>;
  totalItems: Scalars['Int']['output'];
};

export type FacetListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FacetFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FacetSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type FacetResult = {
  __typename?: 'FacetResult';
  facet: Facet;
  facetValueCounts: Array<FacetValueResult>;
};

export type FacetSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FacetTranslation = {
  __typename?: 'FacetTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FacetValue = Node & {
  __typename?: 'FacetValue';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  facet: Facet;
  facetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<FacetValueTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * Used to construct boolean expressions for filtering search results
 * by FacetValue ID. Examples:
 *
 * * ID=1 OR ID=2: `{ facetValueFilters: [{ or: [1,2] }] }`
 * * ID=1 AND ID=2: `{ facetValueFilters: [{ and: 1 }, { and: 2 }] }`
 * * ID=1 AND (ID=2 OR ID=3): `{ facetValueFilters: [{ and: 1 }, { or: [2,3] }] }`
 */
export type FacetValueFilterInput = {
  and?: InputMaybe<Scalars['ID']['input']>;
  or?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FacetValueFilterParameter = {
  _and?: InputMaybe<Array<FacetValueFilterParameter>>;
  _or?: InputMaybe<Array<FacetValueFilterParameter>>;
  code?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  facetId?: InputMaybe<IdOperators>;
  id?: InputMaybe<IdOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type FacetValueList = PaginatedList & {
  __typename?: 'FacetValueList';
  items: Array<FacetValue>;
  totalItems: Scalars['Int']['output'];
};

export type FacetValueListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<FacetValueFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<FacetValueSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Which FacetValues are present in the products returned
 * by the search, and in what quantity.
 */
export type FacetValueResult = {
  __typename?: 'FacetValueResult';
  count: Scalars['Int']['output'];
  facetValue: FacetValue;
};

export type FacetValueSortParameter = {
  code?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  facetId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type FacetValueTranslation = {
  __typename?: 'FacetValueTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type FacetsFilterInput = {
  facets: Array<FacetFilter>;
  includeNullValues?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FloatCustomFieldConfig = CustomField & {
  __typename?: 'FloatCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type FloatStructFieldConfig = StructField & {
  __typename?: 'FloatStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  step?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type Fulfillment = Node & {
  __typename?: 'Fulfillment';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  lines: Array<FulfillmentLine>;
  method: Scalars['String']['output'];
  state: Scalars['String']['output'];
  /** @deprecated Use the `lines` field instead */
  summary: Array<FulfillmentLine>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type FulfillmentLine = {
  __typename?: 'FulfillmentLine';
  fulfillment: Fulfillment;
  fulfillmentId: Scalars['ID']['output'];
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
};

export type GeoDistance = {
  __typename?: 'GeoDistance';
  distanceInMeters: Scalars['Float']['output'];
  field: Scalars['String']['output'];
};

export type Geopoint = {
  __typename?: 'Geopoint';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeopointSort = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
  sort: SortOrder;
};

export type GetChannelResult = Channel | NoChannelForCountryCodeError;

export enum GlobalFlag {
  False = 'FALSE',
  Inherit = 'INHERIT',
  True = 'TRUE'
}

/** Returned when attempting to set the Customer on a guest checkout when the configured GuestCheckoutStrategy does not allow it. */
export type GuestCheckoutError = ErrorResult & {
  __typename?: 'GuestCheckoutError';
  errorCode: ErrorCode;
  errorDetail: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type HistoryEntry = Node & {
  __typename?: 'HistoryEntry';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  data: Scalars['JSON']['output'];
  id: Scalars['ID']['output'];
  type: HistoryEntryType;
  updatedAt: Scalars['DateTime']['output'];
};

export type HistoryEntryFilterParameter = {
  _and?: InputMaybe<Array<HistoryEntryFilterParameter>>;
  _or?: InputMaybe<Array<HistoryEntryFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  id?: InputMaybe<IdOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type HistoryEntryList = PaginatedList & {
  __typename?: 'HistoryEntryList';
  items: Array<HistoryEntry>;
  totalItems: Scalars['Int']['output'];
};

export type HistoryEntryListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<HistoryEntryFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<HistoryEntrySortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type HistoryEntrySortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum HistoryEntryType {
  CustomerAddedToGroup = 'CUSTOMER_ADDED_TO_GROUP',
  CustomerAddressCreated = 'CUSTOMER_ADDRESS_CREATED',
  CustomerAddressDeleted = 'CUSTOMER_ADDRESS_DELETED',
  CustomerAddressUpdated = 'CUSTOMER_ADDRESS_UPDATED',
  CustomerDetailUpdated = 'CUSTOMER_DETAIL_UPDATED',
  CustomerEmailUpdateRequested = 'CUSTOMER_EMAIL_UPDATE_REQUESTED',
  CustomerEmailUpdateVerified = 'CUSTOMER_EMAIL_UPDATE_VERIFIED',
  CustomerNote = 'CUSTOMER_NOTE',
  CustomerPasswordResetRequested = 'CUSTOMER_PASSWORD_RESET_REQUESTED',
  CustomerPasswordResetVerified = 'CUSTOMER_PASSWORD_RESET_VERIFIED',
  CustomerPasswordUpdated = 'CUSTOMER_PASSWORD_UPDATED',
  CustomerRegistered = 'CUSTOMER_REGISTERED',
  CustomerRemovedFromGroup = 'CUSTOMER_REMOVED_FROM_GROUP',
  CustomerVerified = 'CUSTOMER_VERIFIED',
  OrderCancellation = 'ORDER_CANCELLATION',
  OrderCouponApplied = 'ORDER_COUPON_APPLIED',
  OrderCouponRemoved = 'ORDER_COUPON_REMOVED',
  OrderCustomerUpdated = 'ORDER_CUSTOMER_UPDATED',
  OrderFulfillment = 'ORDER_FULFILLMENT',
  OrderFulfillmentTransition = 'ORDER_FULFILLMENT_TRANSITION',
  OrderModified = 'ORDER_MODIFIED',
  OrderNote = 'ORDER_NOTE',
  OrderPaymentTransition = 'ORDER_PAYMENT_TRANSITION',
  OrderRefundTransition = 'ORDER_REFUND_TRANSITION',
  OrderStateTransition = 'ORDER_STATE_TRANSITION'
}

/** Operators for filtering on a list of ID fields */
export type IdListOperators = {
  inList: Scalars['ID']['input'];
};

/** Operators for filtering on an ID field */
export type IdOperators = {
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Returned if the token used to change a Customer's email address is valid, but has
 * expired according to the `verificationTokenDuration` setting in the AuthOptions.
 */
export type IdentifierChangeTokenExpiredError = ErrorResult & {
  __typename?: 'IdentifierChangeTokenExpiredError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/**
 * Returned if the token used to change a Customer's email address is either
 * invalid or does not match any expected tokens.
 */
export type IdentifierChangeTokenInvalidError = ErrorResult & {
  __typename?: 'IdentifierChangeTokenInvalidError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when attempting to add a Payment using a PaymentMethod for which the Order is not eligible. */
export type IneligiblePaymentMethodError = ErrorResult & {
  __typename?: 'IneligiblePaymentMethodError';
  eligibilityCheckerMessage?: Maybe<Scalars['String']['output']>;
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when attempting to set a ShippingMethod for which the Order is not eligible */
export type IneligibleShippingMethodError = ErrorResult & {
  __typename?: 'IneligibleShippingMethodError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export enum InfixMode {
  Always = 'ALWAYS',
  Fallback = 'FALLBACK',
  Off = 'OFF'
}

/** Returned when attempting to add more items to the Order than are available */
export type InsufficientStockError = ErrorResult & {
  __typename?: 'InsufficientStockError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  order: Order;
  quantityAvailable: Scalars['Int']['output'];
};

export type IntCustomFieldConfig = CustomField & {
  __typename?: 'IntCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type IntStructFieldConfig = StructField & {
  __typename?: 'IntStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  max?: Maybe<Scalars['Int']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  step?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

/** Returned if the user authentication credentials are not valid */
export type InvalidCredentialsError = ErrorResult & {
  __typename?: 'InvalidCredentialsError';
  authenticationError: Scalars['String']['output'];
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type InvalidVatError = ErrorResult & {
  __typename?: 'InvalidVatError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Kpis = {
  __typename?: 'Kpis';
  allOrders: Scalars['Int']['output'];
  deliveredOrders: Scalars['Int']['output'];
  inProcessingOrders: Scalars['Int']['output'];
  inShippingOrders: Scalars['Int']['output'];
};

/**
 * @description
 * Languages in the form of a ISO 639-1 language code with optional
 * region or script modifier (e.g. de_AT). The selection available is based
 * on the [Unicode CLDR summary list](https://unicode-org.github.io/cldr-staging/charts/37/summary/root.html)
 * and includes the major spoken languages of the world and any widely-used variants.
 *
 * @docsCategory common
 */
export enum LanguageCode {
  /** Afrikaans */
  Af = 'af',
  /** Akan */
  Ak = 'ak',
  /** Amharic */
  Am = 'am',
  /** Arabic */
  Ar = 'ar',
  /** Assamese */
  As = 'as',
  /** Azerbaijani */
  Az = 'az',
  /** Belarusian */
  Be = 'be',
  /** Bulgarian */
  Bg = 'bg',
  /** Bambara */
  Bm = 'bm',
  /** Bangla */
  Bn = 'bn',
  /** Tibetan */
  Bo = 'bo',
  /** Breton */
  Br = 'br',
  /** Bosnian */
  Bs = 'bs',
  /** Catalan */
  Ca = 'ca',
  /** Chechen */
  Ce = 'ce',
  /** Corsican */
  Co = 'co',
  /** Czech */
  Cs = 'cs',
  /** Church Slavic */
  Cu = 'cu',
  /** Welsh */
  Cy = 'cy',
  /** Danish */
  Da = 'da',
  /** German */
  De = 'de',
  /** Austrian German */
  DeAt = 'de_AT',
  /** Swiss High German */
  DeCh = 'de_CH',
  /** Dzongkha */
  Dz = 'dz',
  /** Ewe */
  Ee = 'ee',
  /** Greek */
  El = 'el',
  /** English */
  En = 'en',
  /** Australian English */
  EnAu = 'en_AU',
  /** Canadian English */
  EnCa = 'en_CA',
  /** British English */
  EnGb = 'en_GB',
  /** American English */
  EnUs = 'en_US',
  /** Esperanto */
  Eo = 'eo',
  /** Spanish */
  Es = 'es',
  /** European Spanish */
  EsEs = 'es_ES',
  /** Mexican Spanish */
  EsMx = 'es_MX',
  /** Estonian */
  Et = 'et',
  /** Basque */
  Eu = 'eu',
  /** Persian */
  Fa = 'fa',
  /** Dari */
  FaAf = 'fa_AF',
  /** Fulah */
  Ff = 'ff',
  /** Finnish */
  Fi = 'fi',
  /** Faroese */
  Fo = 'fo',
  /** French */
  Fr = 'fr',
  /** Canadian French */
  FrCa = 'fr_CA',
  /** Swiss French */
  FrCh = 'fr_CH',
  /** Western Frisian */
  Fy = 'fy',
  /** Irish */
  Ga = 'ga',
  /** Scottish Gaelic */
  Gd = 'gd',
  /** Galician */
  Gl = 'gl',
  /** Gujarati */
  Gu = 'gu',
  /** Manx */
  Gv = 'gv',
  /** Hausa */
  Ha = 'ha',
  /** Hebrew */
  He = 'he',
  /** Hindi */
  Hi = 'hi',
  /** Croatian */
  Hr = 'hr',
  /** Haitian Creole */
  Ht = 'ht',
  /** Hungarian */
  Hu = 'hu',
  /** Armenian */
  Hy = 'hy',
  /** Interlingua */
  Ia = 'ia',
  /** Indonesian */
  Id = 'id',
  /** Igbo */
  Ig = 'ig',
  /** Sichuan Yi */
  Ii = 'ii',
  /** Icelandic */
  Is = 'is',
  /** Italian */
  It = 'it',
  /** Japanese */
  Ja = 'ja',
  /** Javanese */
  Jv = 'jv',
  /** Georgian */
  Ka = 'ka',
  /** Kikuyu */
  Ki = 'ki',
  /** Kazakh */
  Kk = 'kk',
  /** Kalaallisut */
  Kl = 'kl',
  /** Khmer */
  Km = 'km',
  /** Kannada */
  Kn = 'kn',
  /** Korean */
  Ko = 'ko',
  /** Kashmiri */
  Ks = 'ks',
  /** Kurdish */
  Ku = 'ku',
  /** Cornish */
  Kw = 'kw',
  /** Kyrgyz */
  Ky = 'ky',
  /** Latin */
  La = 'la',
  /** Luxembourgish */
  Lb = 'lb',
  /** Ganda */
  Lg = 'lg',
  /** Lingala */
  Ln = 'ln',
  /** Lao */
  Lo = 'lo',
  /** Lithuanian */
  Lt = 'lt',
  /** Luba-Katanga */
  Lu = 'lu',
  /** Latvian */
  Lv = 'lv',
  /** Malagasy */
  Mg = 'mg',
  /** Maori */
  Mi = 'mi',
  /** Macedonian */
  Mk = 'mk',
  /** Malayalam */
  Ml = 'ml',
  /** Mongolian */
  Mn = 'mn',
  /** Marathi */
  Mr = 'mr',
  /** Malay */
  Ms = 'ms',
  /** Maltese */
  Mt = 'mt',
  /** Burmese */
  My = 'my',
  /** Norwegian Bokmål */
  Nb = 'nb',
  /** North Ndebele */
  Nd = 'nd',
  /** Nepali */
  Ne = 'ne',
  /** Dutch */
  Nl = 'nl',
  /** Flemish */
  NlBe = 'nl_BE',
  /** Norwegian Nynorsk */
  Nn = 'nn',
  /** Nyanja */
  Ny = 'ny',
  /** Oromo */
  Om = 'om',
  /** Odia */
  Or = 'or',
  /** Ossetic */
  Os = 'os',
  /** Punjabi */
  Pa = 'pa',
  /** Polish */
  Pl = 'pl',
  /** Pashto */
  Ps = 'ps',
  /** Portuguese */
  Pt = 'pt',
  /** Brazilian Portuguese */
  PtBr = 'pt_BR',
  /** European Portuguese */
  PtPt = 'pt_PT',
  /** Quechua */
  Qu = 'qu',
  /** Romansh */
  Rm = 'rm',
  /** Rundi */
  Rn = 'rn',
  /** Romanian */
  Ro = 'ro',
  /** Moldavian */
  RoMd = 'ro_MD',
  /** Russian */
  Ru = 'ru',
  /** Kinyarwanda */
  Rw = 'rw',
  /** Sanskrit */
  Sa = 'sa',
  /** Sindhi */
  Sd = 'sd',
  /** Northern Sami */
  Se = 'se',
  /** Sango */
  Sg = 'sg',
  /** Sinhala */
  Si = 'si',
  /** Slovak */
  Sk = 'sk',
  /** Slovenian */
  Sl = 'sl',
  /** Samoan */
  Sm = 'sm',
  /** Shona */
  Sn = 'sn',
  /** Somali */
  So = 'so',
  /** Albanian */
  Sq = 'sq',
  /** Serbian */
  Sr = 'sr',
  /** Southern Sotho */
  St = 'st',
  /** Sundanese */
  Su = 'su',
  /** Swedish */
  Sv = 'sv',
  /** Swahili */
  Sw = 'sw',
  /** Congo Swahili */
  SwCd = 'sw_CD',
  /** Tamil */
  Ta = 'ta',
  /** Telugu */
  Te = 'te',
  /** Tajik */
  Tg = 'tg',
  /** Thai */
  Th = 'th',
  /** Tigrinya */
  Ti = 'ti',
  /** Turkmen */
  Tk = 'tk',
  /** Tongan */
  To = 'to',
  /** Turkish */
  Tr = 'tr',
  /** Tatar */
  Tt = 'tt',
  /** Uyghur */
  Ug = 'ug',
  /** Ukrainian */
  Uk = 'uk',
  /** Urdu */
  Ur = 'ur',
  /** Uzbek */
  Uz = 'uz',
  /** Vietnamese */
  Vi = 'vi',
  /** Volapük */
  Vo = 'vo',
  /** Wolof */
  Wo = 'wo',
  /** Xhosa */
  Xh = 'xh',
  /** Yiddish */
  Yi = 'yi',
  /** Yoruba */
  Yo = 'yo',
  /** Chinese */
  Zh = 'zh',
  /** Simplified Chinese */
  ZhHans = 'zh_Hans',
  /** Traditional Chinese */
  ZhHant = 'zh_Hant',
  /** Zulu */
  Zu = 'zu'
}

export type LocaleStringCustomFieldConfig = CustomField & {
  __typename?: 'LocaleStringCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  length?: Maybe<Scalars['Int']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type LocaleTextCustomFieldConfig = CustomField & {
  __typename?: 'LocaleTextCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type LocalizedString = {
  __typename?: 'LocalizedString';
  languageCode: LanguageCode;
  value: Scalars['String']['output'];
};

export enum LogicalOperator {
  And = 'AND',
  Or = 'OR'
}

export type MimeTypeError = ErrorResult & {
  __typename?: 'MimeTypeError';
  errorCode: ErrorCode;
  fileName: Scalars['String']['output'];
  message: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
};

/** Returned when attempting to register or verify a customer account without a password, when one is required. */
export type MissingPasswordError = ErrorResult & {
  __typename?: 'MissingPasswordError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addCompanyAddress: AddCompanyAddressResult;
  /** Adds an item to the Order. If custom fields are defined on the OrderLine entity, a third argument 'customFields' will be available. */
  addItemToOrder: UpdateOrderItemsResult;
  addItemToOrderBySku: AddItemToOrderBySkuResult;
  addMultipleItemsToOrder: AddMultipleItemsToOrderResult;
  /** Add a Payment to the Order */
  addPaymentToOrder: AddPaymentToOrderResult;
  addToWishlist: Wishlist;
  addWishlistItemsToOrder: Order;
  /** Adjusts an OrderLine. If custom fields are defined on the OrderLine entity, a third argument 'customFields' of type `OrderLineCustomFieldsInput` will be available. */
  adjustOrderLine: UpdateOrderItemsResult;
  /** Applies the given coupon code to the active Order */
  applyCouponCode: ApplyCouponCodeResult;
  /** Authenticates the user using a named authentication strategy */
  authenticate: AuthenticationResult;
  createAssets: Array<CreateShopAssetResult>;
  createCompany: CreateCompanyResult;
  /** Create a new Customer Address */
  createCustomerAddress: Address;
  createOffer: CreateOfferResult;
  createOfferPrice: CreateOfferPriceResult;
  createOfferPrices: CreateOfferPricesResult;
  createWishlist: Wishlist;
  deleteCompany: DeleteCompanyResult;
  deleteCompanyAddress: DeleteCompanyAddressResult;
  /** Delete an existing Address */
  deleteCustomerAddress: Success;
  deleteOffer: DeleteOfferResult;
  deleteOfferPrice: DeleteOfferPriceResult;
  deleteWishlist: DeletionResponse;
  logSearchListViewed: Scalars['Boolean']['output'];
  logSearchResultClicked: Scalars['Boolean']['output'];
  /**
   * Authenticates the user using the native authentication strategy. This mutation is an alias for authenticate({ native: { ... }})
   *
   * The `rememberMe` option applies when using cookie-based sessions, and if `true` it will set the maxAge of the session cookie
   * to 1 year.
   */
  login: NativeAuthenticationResult;
  /** End the current authenticated session */
  logout: Success;
  moveWishlistItems?: Maybe<Wishlist>;
  /** Regenerate and send a verification token for a new Customer registration. Only applicable if `authOptions.requireVerification` is set to true. */
  refreshCustomerVerification: RefreshCustomerVerificationResult;
  registerB2BCustomer: RegisterB2BCustomerAccountResult;
  /**
   * Register a Customer account with the given credentials. There are three possible registration flows:
   *
   * _If `authOptions.requireVerification` is set to `true`:_
   *
   * 1. **The Customer is registered _with_ a password**. A verificationToken will be created (and typically emailed to the Customer). That
   *    verificationToken would then be passed to the `verifyCustomerAccount` mutation _without_ a password. The Customer is then
   *    verified and authenticated in one step.
   * 2. **The Customer is registered _without_ a password**. A verificationToken will be created (and typically emailed to the Customer). That
   *    verificationToken would then be passed to the `verifyCustomerAccount` mutation _with_ the chosen password of the Customer. The Customer is then
   *    verified and authenticated in one step.
   *
   * _If `authOptions.requireVerification` is set to `false`:_
   *
   * 3. The Customer _must_ be registered _with_ a password. No further action is needed - the Customer is able to authenticate immediately.
   */
  registerCustomerAccount: RegisterCustomerAccountResult;
  /** Remove all OrderLine from the Order */
  removeAllOrderLines: RemoveOrderItemsResult;
  removeAllOrderLinesAndStockMovements: RemoveOrderItemsResult;
  /** Removes the given coupon code from the active Order */
  removeCouponCode?: Maybe<Order>;
  removeFromWishlist: Wishlist;
  /** Remove an OrderLine from the Order */
  removeOrderLine: RemoveOrderItemsResult;
  /** Requests a password reset email to be sent */
  requestPasswordReset?: Maybe<RequestPasswordResetResult>;
  /**
   * Request to update the emailAddress of the active Customer. If `authOptions.requireVerification` is enabled
   * (as is the default), then the `identifierChangeToken` will be assigned to the current User and
   * a IdentifierChangeRequestEvent will be raised. This can then be used e.g. by the EmailPlugin to email
   * that verification token to the Customer, which is then used to verify the change of email address.
   */
  requestUpdateCustomerEmailAddress: RequestUpdateCustomerEmailAddressResult;
  /** Resets a Customer's password based on the provided token */
  resetPassword: ResetPasswordResult;
  setActiveCompany: SetActiveCompanyResult;
  /** Set the Customer for the Order. Required only if the Customer is not currently logged in */
  setCustomerForOrder: SetCustomerForOrderResult;
  /** Sets the billing address for the active Order */
  setOrderBillingAddress: ActiveOrderResult;
  /** Allows any custom fields to be set for the active Order */
  setOrderCustomFields: ActiveOrderResult;
  setOrderPaymentMethod: SetOrderPaymentMethodResult;
  /** Sets the shipping address for the active Order */
  setOrderShippingAddress: ActiveOrderResult;
  /**
   * Sets the shipping method by id, which can be obtained with the `eligibleShippingMethods` query.
   * An Order can have multiple shipping methods, in which case you can pass an array of ids. In this case,
   * you should configure a custom ShippingLineAssignmentStrategy in order to know which OrderLines each
   * shipping method will apply to.
   */
  setOrderShippingMethod: SetOrderShippingMethodResult;
  setWishlistVisibility: Wishlist;
  subscribeToNewsletter: Success;
  toggleCustomerSpecificPrices: ToggleCustomerSpecificPricesResult;
  transformOfferToCart: TransformOfferToCartResult;
  /** Transitions an Order to a new state. Valid next states can be found by querying `nextOrderStates` */
  transitionOrderToState?: Maybe<TransitionOrderToStateResult>;
  /** Unsets the billing address for the active Order. Available since version 3.1.0 */
  unsetOrderBillingAddress: ActiveOrderResult;
  /** Unsets the shipping address for the active Order. Available since version 3.1.0 */
  unsetOrderShippingAddress: ActiveOrderResult;
  unsubscribeToNewsletter: Success;
  updateCompany: UpdateCompanyResult;
  updateCompanyAddress: UpdateCompanyAddressResult;
  /** Update an existing Customer */
  updateCustomer: Customer;
  /** Update an existing Address */
  updateCustomerAddress: Address;
  /**
   * Confirm the update of the emailAddress with the provided token, which has been generated by the
   * `requestUpdateCustomerEmailAddress` mutation.
   */
  updateCustomerEmailAddress: UpdateCustomerEmailAddressResult;
  /** Update the password of the active Customer */
  updateCustomerPassword: UpdateCustomerPasswordResult;
  updateOffer: UpdateOfferResult;
  updateOfferPrice: UpdateOfferPriceResult;
  updateOfferSettings: UpdateOfferSettingsResult;
  updateOfferState: UpdateOfferStateResult;
  updateWishlist: Wishlist;
  /**
   * Verify a Customer email address with the token sent to that address. Only applicable if `authOptions.requireVerification` is set to true.
   *
   * If the Customer was not registered with a password in the `registerCustomerAccount` mutation, the password _must_ be
   * provided here.
   */
  verifyCustomerAccount: VerifyCustomerAccountResult;
};


export type MutationAddCompanyAddressArgs = {
  address: CreateCompanyAddressInput;
};


export type MutationAddItemToOrderArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationAddItemToOrderBySkuArgs = {
  input: AddItemToOrderBySkuInput;
};


export type MutationAddMultipleItemsToOrderArgs = {
  input: Array<AddItemToOrderBySkuInput>;
};


export type MutationAddPaymentToOrderArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  input: PaymentInput;
};


export type MutationAddToWishlistArgs = {
  productVariantId: Scalars['ID']['input'];
  wishlistId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAddWishlistItemsToOrderArgs = {
  itemIds: Array<Scalars['ID']['input']>;
};


export type MutationAdjustOrderLineArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  customFields?: InputMaybe<OrderLineCustomFieldsInput>;
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
};


export type MutationApplyCouponCodeArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  couponCode: Scalars['String']['input'];
};


export type MutationAuthenticateArgs = {
  input: AuthenticationInput;
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateAssetsArgs = {
  input: Array<CreateAssetInput>;
};


export type MutationCreateCompanyArgs = {
  input: CreateCompanyInput;
};


export type MutationCreateCustomerAddressArgs = {
  input: CreateAddressInput;
};


export type MutationCreateOfferArgs = {
  input: CreateOfferInput;
};


export type MutationCreateOfferPriceArgs = {
  input: CreateOfferPriceInput;
};


export type MutationCreateOfferPricesArgs = {
  input: Array<CreateOfferPriceInput>;
};


export type MutationCreateWishlistArgs = {
  input: CreateWishlistInput;
};


export type MutationDeleteCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type MutationDeleteCompanyAddressArgs = {
  addressId: Scalars['ID']['input'];
};


export type MutationDeleteCustomerAddressArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteOfferArgs = {
  offerId: Scalars['ID']['input'];
};


export type MutationDeleteOfferPriceArgs = {
  offerPriceId: Scalars['ID']['input'];
};


export type MutationDeleteWishlistArgs = {
  id: Scalars['ID']['input'];
};


export type MutationLogSearchListViewedArgs = {
  input: SearchListViewedEventInput;
};


export type MutationLogSearchResultClickedArgs = {
  input: SearchResultClickedEventInput;
};


export type MutationLoginArgs = {
  password: Scalars['String']['input'];
  rememberMe?: InputMaybe<Scalars['Boolean']['input']>;
  username: Scalars['String']['input'];
};


export type MutationMoveWishlistItemsArgs = {
  itemIds: Array<Scalars['ID']['input']>;
  targetWishlistId: Scalars['ID']['input'];
};


export type MutationRefreshCustomerVerificationArgs = {
  emailAddress: Scalars['String']['input'];
};


export type MutationRegisterB2BCustomerArgs = {
  input?: InputMaybe<B2BRegisterInput>;
};


export type MutationRegisterCustomerAccountArgs = {
  input: RegisterCustomerInput;
};


export type MutationRemoveAllOrderLinesArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
};


export type MutationRemoveCouponCodeArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  couponCode: Scalars['String']['input'];
};


export type MutationRemoveFromWishlistArgs = {
  itemIds: Array<Scalars['ID']['input']>;
  wishlistId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRemoveOrderLineArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  orderLineId: Scalars['ID']['input'];
};


export type MutationRequestPasswordResetArgs = {
  emailAddress: Scalars['String']['input'];
};


export type MutationRequestUpdateCustomerEmailAddressArgs = {
  newEmailAddress: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationResetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationSetActiveCompanyArgs = {
  companyId: Scalars['ID']['input'];
};


export type MutationSetCustomerForOrderArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  input: CreateCustomerInput;
};


export type MutationSetOrderBillingAddressArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  input: CreateAddressInput;
};


export type MutationSetOrderCustomFieldsArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  input: UpdateOrderInput;
};


export type MutationSetOrderPaymentMethodArgs = {
  input: PaymentInput;
};


export type MutationSetOrderShippingAddressArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  input: CreateAddressInput;
};


export type MutationSetOrderShippingMethodArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  shippingMethodId: Array<Scalars['ID']['input']>;
};


export type MutationSetWishlistVisibilityArgs = {
  id: Scalars['ID']['input'];
  isPublic: Scalars['Boolean']['input'];
};


export type MutationSubscribeToNewsletterArgs = {
  input: NewsletterAddressInput;
};


export type MutationTransformOfferToCartArgs = {
  offerId: Scalars['ID']['input'];
};


export type MutationTransitionOrderToStateArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
  state: Scalars['String']['input'];
};


export type MutationUnsetOrderBillingAddressArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
};


export type MutationUnsetOrderShippingAddressArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
};


export type MutationUnsubscribeToNewsletterArgs = {
  input: NewsletterAddressInput;
};


export type MutationUpdateCompanyArgs = {
  companyId: Scalars['ID']['input'];
  input: UpdateCompanyInput;
};


export type MutationUpdateCompanyAddressArgs = {
  address: UpdateCompanyAddressInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateCustomerAddressArgs = {
  input: UpdateAddressInput;
};


export type MutationUpdateCustomerEmailAddressArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateCustomerPasswordArgs = {
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
};


export type MutationUpdateOfferArgs = {
  input: UpdateOfferInput;
};


export type MutationUpdateOfferPriceArgs = {
  input: UpdateOfferPriceInput;
};


export type MutationUpdateOfferSettingsArgs = {
  input: UpdateOfferSettingsInput;
};


export type MutationUpdateOfferStateArgs = {
  input: UpdateOfferStateInput;
};


export type MutationUpdateWishlistArgs = {
  input: UpdateWishlistInput;
};


export type MutationVerifyCustomerAccountArgs = {
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};

export type NativeAuthInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Returned when attempting an operation that relies on the NativeAuthStrategy, if that strategy is not configured. */
export type NativeAuthStrategyError = ErrorResult & {
  __typename?: 'NativeAuthStrategyError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type NativeAuthenticationResult = CurrentUser | InvalidCredentialsError | NativeAuthStrategyError | NotVerifiedError;

/** Returned when attempting to set a negative OrderLine quantity. */
export type NegativeQuantityError = ErrorResult & {
  __typename?: 'NegativeQuantityError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type NewsletterAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Returned when invoking a mutation which depends on there being an active Order on the
 * current session.
 */
export type NoActiveOrderError = ErrorResult & {
  __typename?: 'NoActiveOrderError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type NoChannelForCountryCodeError = ErrorResult & {
  __typename?: 'NoChannelForCountryCodeError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type NotAllowedError = ErrorResult & {
  __typename?: 'NotAllowedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/**
 * Returned if `authOptions.requireVerification` is set to `true` (which is the default)
 * and an unverified user attempts to authenticate.
 */
export type NotVerifiedError = ErrorResult & {
  __typename?: 'NotVerifiedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Operators for filtering on a list of Number fields */
export type NumberListOperators = {
  inList: Scalars['Float']['input'];
};

/** Operators for filtering on a Int or Float field */
export type NumberOperators = {
  between?: InputMaybe<NumberRange>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
};

export type NumberRange = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type Offer = Node & {
  __typename?: 'Offer';
  additionalDiscount?: Maybe<Scalars['Int']['output']>;
  address: Scalars['String']['output'];
  company: Company;
  createdAt: Scalars['DateTime']['output'];
  customOfferLines?: Maybe<Array<OfferOrderLine>>;
  date: Scalars['DateTime']['output'];
  footerText: Scalars['String']['output'];
  headerText: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  number: Scalars['String']['output'];
  order: Order;
  reference: Scalars['String']['output'];
  status: OfferStatus;
  subject: Scalars['String']['output'];
  termsOfDelivery: Scalars['String']['output'];
  termsOfPayment: Scalars['String']['output'];
};

export type OfferCustomerSpecificPrice = Node & {
  __typename?: 'OfferCustomerSpecificPrice';
  company: Company;
  currencyCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  productVariant: ProductVariant;
};

export type OfferFilterOptions = {
  address?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  date?: InputMaybe<DateOperators>;
  footerText?: InputMaybe<StringOperators>;
  headerText?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  number?: InputMaybe<StringOperators>;
  reference?: InputMaybe<StringOperators>;
  status?: InputMaybe<StringOperators>;
  subject?: InputMaybe<StringOperators>;
  termsOfDelivery?: InputMaybe<StringOperators>;
  termsOfPayment?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type OfferListOptions = {
  filter?: InputMaybe<OfferFilterOptions>;
  filterOperator?: InputMaybe<LogicalOperator>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OfferSortOptions>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferOrderLine = Node & {
  __typename?: 'OfferOrderLine';
  alternative: Scalars['Boolean']['output'];
  discount: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Order;
  positionTotal: Scalars['Int']['output'];
  price: Scalars['Int']['output'];
  productVariant?: Maybe<ProductVariant>;
  quantity: Scalars['Int']['output'];
  taxRate: Scalars['Int']['output'];
};

export type OfferPrice = Node & {
  __typename?: 'OfferPrice';
  company: Company;
  currencyCode: CurrencyCode;
  id: Scalars['ID']['output'];
  price: Scalars['Int']['output'];
  productVariant: ProductVariant;
};

export type OfferPriceFilterParameter = {
  _and?: InputMaybe<Array<OfferPriceFilterParameter>>;
  _or?: InputMaybe<Array<OfferPriceFilterParameter>>;
  currencyCode?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  price?: InputMaybe<NumberOperators>;
};

export type OfferPriceList = PaginatedList & {
  __typename?: 'OfferPriceList';
  items: Array<OfferPrice>;
  totalItems: Scalars['Int']['output'];
};

export type OfferPriceListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<OfferPriceFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<OfferPriceSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferPriceOptions = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OfferPriceSortParameter = {
  id?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
};

export type OfferSettings = Node & {
  __typename?: 'OfferSettings';
  accountNumber?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  bankCode?: Maybe<Scalars['String']['output']>;
  bankName?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  company: Company;
  companyRegister?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  iban?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  vat?: Maybe<Scalars['String']['output']>;
};

export type OfferSortOptions = {
  address?: InputMaybe<SortOptions>;
  createdAt?: InputMaybe<SortOptions>;
  date?: InputMaybe<SortOptions>;
  footerText?: InputMaybe<SortOptions>;
  headerText?: InputMaybe<SortOptions>;
  id?: InputMaybe<SortOptions>;
  number?: InputMaybe<SortOptions>;
  reference?: InputMaybe<SortOptions>;
  status?: InputMaybe<SortOptions>;
  subject?: InputMaybe<SortOptions>;
  termsOfDelivery?: InputMaybe<SortOptions>;
  termsOfPayment?: InputMaybe<SortOptions>;
  updatedAt?: InputMaybe<SortOptions>;
};

export enum OfferStatus {
  Accepted = 'accepted',
  Declined = 'declined',
  Draft = 'draft',
  Open = 'open'
}

export type Order = Node & {
  __typename?: 'Order';
  /** An order is active as long as the payment process has not been completed */
  active: Scalars['Boolean']['output'];
  billingAddress?: Maybe<OrderAddress>;
  /** A unique code for the Order */
  code: Scalars['String']['output'];
  /** An array of all coupon codes applied to the Order */
  couponCodes: Array<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: CurrencyCode;
  customFields?: Maybe<OrderCustomFields>;
  customer?: Maybe<Customer>;
  discounts: Array<Discount>;
  fulfillments?: Maybe<Array<Fulfillment>>;
  history: HistoryEntryList;
  id: Scalars['ID']['output'];
  lines: Array<OrderLine>;
  /**
   * The date & time that the Order was placed, i.e. the Customer
   * completed the checkout and the Order is no longer "active"
   */
  orderPlacedAt?: Maybe<Scalars['DateTime']['output']>;
  payments?: Maybe<Array<Payment>>;
  /** Promotions applied to the order. Only gets populated after the payment process has completed. */
  promotions: Array<Promotion>;
  shipping: Scalars['Money']['output'];
  shippingAddress?: Maybe<OrderAddress>;
  shippingLines: Array<ShippingLine>;
  shippingWithTax: Scalars['Money']['output'];
  state: Scalars['String']['output'];
  /**
   * The subTotal is the total of all OrderLines in the Order. This figure also includes any Order-level
   * discounts which have been prorated (proportionally distributed) amongst the items of each OrderLine.
   * To get a total of all OrderLines which does not account for prorated discounts, use the
   * sum of `OrderLine.discountedLinePrice` values.
   */
  subTotal: Scalars['Money']['output'];
  /** Same as subTotal, but inclusive of tax */
  subTotalWithTax: Scalars['Money']['output'];
  /**
   * Surcharges are arbitrary modifications to the Order total which are neither
   * ProductVariants nor discounts resulting from applied Promotions. For example,
   * one-off discounts based on customer interaction, or surcharges based on payment
   * methods.
   */
  surcharges: Array<Surcharge>;
  /** A summary of the taxes being applied to this Order */
  taxSummary: Array<OrderTaxSummary>;
  /** Equal to subTotal plus shipping */
  total: Scalars['Money']['output'];
  totalQuantity: Scalars['Int']['output'];
  /** The final payable amount. Equal to subTotalWithTax plus shippingWithTax */
  totalWithTax: Scalars['Money']['output'];
  type: OrderType;
  updatedAt: Scalars['DateTime']['output'];
};


export type OrderHistoryArgs = {
  options?: InputMaybe<HistoryEntryListOptions>;
};

export type OrderAddress = {
  __typename?: 'OrderAddress';
  city?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  customFields?: Maybe<Scalars['JSON']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  province?: Maybe<Scalars['String']['output']>;
  streetLine1?: Maybe<Scalars['String']['output']>;
  streetLine2?: Maybe<Scalars['String']['output']>;
};

export type OrderCodeActiveOrderInput = {
  code?: InputMaybe<Scalars['String']['input']>;
};

export type OrderCustomFields = {
  __typename?: 'OrderCustomFields';
  comment?: Maybe<Scalars['String']['output']>;
  commission?: Maybe<Scalars['String']['output']>;
  company?: Maybe<Company>;
  confirmationEmailSent?: Maybe<Scalars['Boolean']['output']>;
  erpId?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  savedPaymentMethod?: Maybe<Scalars['String']['output']>;
};

export type OrderDocument = Node & {
  __typename?: 'OrderDocument';
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Order;
  source?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type OrderDocumentFilter = {
  orderId: Scalars['ID']['input'];
};

export type OrderDocumentFilterParameter = {
  _and?: InputMaybe<Array<OrderDocumentFilterParameter>>;
  _or?: InputMaybe<Array<OrderDocumentFilterParameter>>;
  id?: InputMaybe<IdOperators>;
  name?: InputMaybe<StringOperators>;
  source?: InputMaybe<StringOperators>;
  type?: InputMaybe<StringOperators>;
};

export type OrderDocumentList = PaginatedList & {
  __typename?: 'OrderDocumentList';
  items: Array<OrderDocument>;
  totalItems: Scalars['Int']['output'];
};

export type OrderDocumentListOptions = {
  filter: OrderDocumentFilter;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<OrderDocumentSortParameter>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderDocumentSortParameter = {
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  source?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type OrderFilterParameter = {
  _and?: InputMaybe<Array<OrderFilterParameter>>;
  _or?: InputMaybe<Array<OrderFilterParameter>>;
  active?: InputMaybe<BooleanOperators>;
  code?: InputMaybe<StringOperators>;
  comment?: InputMaybe<StringOperators>;
  commission?: InputMaybe<StringOperators>;
  confirmationEmailSent?: InputMaybe<BooleanOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  erpId?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  orderPlacedAt?: InputMaybe<DateOperators>;
  reference?: InputMaybe<StringOperators>;
  savedPaymentMethod?: InputMaybe<StringOperators>;
  shipping?: InputMaybe<NumberOperators>;
  shippingWithTax?: InputMaybe<NumberOperators>;
  state?: InputMaybe<StringOperators>;
  subTotal?: InputMaybe<NumberOperators>;
  subTotalWithTax?: InputMaybe<NumberOperators>;
  total?: InputMaybe<NumberOperators>;
  totalQuantity?: InputMaybe<NumberOperators>;
  totalWithTax?: InputMaybe<NumberOperators>;
  type?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

/** Returned when an order operation is rejected by an OrderInterceptor method. */
export type OrderInterceptorError = ErrorResult & {
  __typename?: 'OrderInterceptorError';
  errorCode: ErrorCode;
  interceptorError: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

/** Returned when the maximum order size limit has been reached. */
export type OrderLimitError = ErrorResult & {
  __typename?: 'OrderLimitError';
  errorCode: ErrorCode;
  maxItems: Scalars['Int']['output'];
  message: Scalars['String']['output'];
};

export type OrderLine = Node & {
  __typename?: 'OrderLine';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<OrderLineCustomFields>;
  /** The price of the line including discounts, excluding tax */
  discountedLinePrice: Scalars['Money']['output'];
  /** The price of the line including discounts and tax */
  discountedLinePriceWithTax: Scalars['Money']['output'];
  /**
   * The price of a single unit including discounts, excluding tax.
   *
   * If Order-level discounts have been applied, this will not be the
   * actual taxable unit price (see `proratedUnitPrice`), but is generally the
   * correct price to display to customers to avoid confusion
   * about the internal handling of distributed Order-level discounts.
   */
  discountedUnitPrice: Scalars['Money']['output'];
  /** The price of a single unit including discounts and tax */
  discountedUnitPriceWithTax: Scalars['Money']['output'];
  discounts: Array<Discount>;
  featuredAsset?: Maybe<Asset>;
  fulfillmentLines?: Maybe<Array<FulfillmentLine>>;
  id: Scalars['ID']['output'];
  /** The total price of the line excluding tax and discounts. */
  linePrice: Scalars['Money']['output'];
  /** The total price of the line including tax but excluding discounts. */
  linePriceWithTax: Scalars['Money']['output'];
  /** The total tax on this line */
  lineTax: Scalars['Money']['output'];
  order: Order;
  /** The quantity at the time the Order was placed */
  orderPlacedQuantity: Scalars['Int']['output'];
  productVariant: ProductVariant;
  /**
   * The actual line price, taking into account both item discounts _and_ prorated (proportionally-distributed)
   * Order-level discounts. This value is the true economic value of the OrderLine, and is used in tax
   * and refund calculations.
   */
  proratedLinePrice: Scalars['Money']['output'];
  /** The proratedLinePrice including tax */
  proratedLinePriceWithTax: Scalars['Money']['output'];
  /**
   * The actual unit price, taking into account both item discounts _and_ prorated (proportionally-distributed)
   * Order-level discounts. This value is the true economic value of the OrderItem, and is used in tax
   * and refund calculations.
   */
  proratedUnitPrice: Scalars['Money']['output'];
  /** The proratedUnitPrice including tax */
  proratedUnitPriceWithTax: Scalars['Money']['output'];
  /** The quantity of items purchased */
  quantity: Scalars['Int']['output'];
  taxLines: Array<TaxLine>;
  taxRate: Scalars['Float']['output'];
  /** The price of a single unit, excluding tax and discounts */
  unitPrice: Scalars['Money']['output'];
  /** Non-zero if the unitPrice has changed since it was initially added to Order */
  unitPriceChangeSinceAdded: Scalars['Money']['output'];
  /** The price of a single unit, including tax but excluding discounts */
  unitPriceWithTax: Scalars['Money']['output'];
  /** Non-zero if the unitPriceWithTax has changed since it was initially added to Order */
  unitPriceWithTaxChangeSinceAdded: Scalars['Money']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type OrderLineCustomFields = {
  __typename?: 'OrderLineCustomFields';
  addedFromWishlistCustomerName?: Maybe<Scalars['String']['output']>;
  addedFromWishlistName?: Maybe<Scalars['String']['output']>;
  offerOrderLine?: Maybe<OfferOrderLine>;
};

export type OrderLineCustomFieldsInput = {
  addedFromWishlistCustomerName?: InputMaybe<Scalars['String']['input']>;
  addedFromWishlistName?: InputMaybe<Scalars['String']['input']>;
  offerOrderLineId?: InputMaybe<Scalars['ID']['input']>;
};

export type OrderList = PaginatedList & {
  __typename?: 'OrderList';
  items: Array<Order>;
  totalItems: Scalars['Int']['output'];
};

export type OrderListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<OrderFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<OrderSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

/** Returned when attempting to modify the contents of an Order that is not in the `AddingItems` state. */
export type OrderModificationError = ErrorResult & {
  __typename?: 'OrderModificationError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when attempting to add a Payment to an Order that is not in the `ArrangingPayment` state. */
export type OrderPaymentStateError = ErrorResult & {
  __typename?: 'OrderPaymentStateError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type OrderSortParameter = {
  code?: InputMaybe<SortOrder>;
  comment?: InputMaybe<SortOrder>;
  commission?: InputMaybe<SortOrder>;
  company?: InputMaybe<SortOrder>;
  confirmationEmailSent?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  erpId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  orderPlacedAt?: InputMaybe<SortOrder>;
  reference?: InputMaybe<SortOrder>;
  savedPaymentMethod?: InputMaybe<SortOrder>;
  shipping?: InputMaybe<SortOrder>;
  shippingWithTax?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  subTotal?: InputMaybe<SortOrder>;
  subTotalWithTax?: InputMaybe<SortOrder>;
  total?: InputMaybe<SortOrder>;
  totalQuantity?: InputMaybe<SortOrder>;
  totalWithTax?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

/** Returned if there is an error in transitioning the Order state */
export type OrderStateTransitionError = ErrorResult & {
  __typename?: 'OrderStateTransitionError';
  errorCode: ErrorCode;
  fromState: Scalars['String']['output'];
  message: Scalars['String']['output'];
  toState: Scalars['String']['output'];
  transitionError: Scalars['String']['output'];
};

/**
 * A summary of the taxes being applied to this order, grouped
 * by taxRate.
 */
export type OrderTaxSummary = {
  __typename?: 'OrderTaxSummary';
  /** A description of this tax */
  description: Scalars['String']['output'];
  /** The total net price of OrderLines to which this taxRate applies */
  taxBase: Scalars['Money']['output'];
  /** The taxRate as a percentage */
  taxRate: Scalars['Float']['output'];
  /** The total tax being applied to the Order at this taxRate */
  taxTotal: Scalars['Money']['output'];
};

export enum OrderType {
  Aggregate = 'Aggregate',
  Regular = 'Regular',
  Seller = 'Seller'
}

export type Organization = Node & {
  __typename?: 'Organization';
  companies?: Maybe<Array<Maybe<Company>>>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type OrganizationList = PaginatedList & {
  __typename?: 'OrganizationList';
  items: Array<Organization>;
  totalItems: Scalars['Int']['output'];
};

export type OrganizationListOptions = {
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type PaginatedList = {
  items: Array<Node>;
  totalItems: Scalars['Int']['output'];
};

/** Returned when attempting to verify a customer account with a password, when a password has already been set. */
export type PasswordAlreadySetError = ErrorResult & {
  __typename?: 'PasswordAlreadySetError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/**
 * Returned if the token used to reset a Customer's password is valid, but has
 * expired according to the `verificationTokenDuration` setting in the AuthOptions.
 */
export type PasswordResetTokenExpiredError = ErrorResult & {
  __typename?: 'PasswordResetTokenExpiredError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/**
 * Returned if the token used to reset a Customer's password is either
 * invalid or does not match any expected tokens.
 */
export type PasswordResetTokenInvalidError = ErrorResult & {
  __typename?: 'PasswordResetTokenInvalidError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/** Returned when attempting to register or verify a customer account where the given password fails password validation. */
export type PasswordValidationError = ErrorResult & {
  __typename?: 'PasswordValidationError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  validationErrorMessage: Scalars['String']['output'];
};

export type Payment = Node & {
  __typename?: 'Payment';
  amount: Scalars['Money']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSON']['output']>;
  method: Scalars['String']['output'];
  refunds: Array<Refund>;
  state: Scalars['String']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Returned when a Payment is declined by the payment provider. */
export type PaymentDeclinedError = ErrorResult & {
  __typename?: 'PaymentDeclinedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  paymentErrorMessage: Scalars['String']['output'];
};

/** Returned when a Payment fails due to an error. */
export type PaymentFailedError = ErrorResult & {
  __typename?: 'PaymentFailedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
  paymentErrorMessage: Scalars['String']['output'];
};

/** Passed as input to the `addPaymentToOrder` mutation. */
export type PaymentInput = {
  /**
   * This field should contain arbitrary data passed to the specified PaymentMethodHandler's `createPayment()` method
   * as the "metadata" argument. For example, it could contain an ID for the payment and other
   * data generated by the payment provider.
   */
  metadata: Scalars['JSON']['input'];
  /** This field should correspond to the `code` property of a PaymentMethod. */
  method: Scalars['String']['input'];
};

export type PaymentMethod = Node & {
  __typename?: 'PaymentMethod';
  checker?: Maybe<ConfigurableOperation>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  handler: ConfigurableOperation;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  translations: Array<PaymentMethodTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type PaymentMethodQuote = {
  __typename?: 'PaymentMethodQuote';
  code: Scalars['String']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  eligibilityMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isEligible: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type PaymentMethodTranslation = {
  __typename?: 'PaymentMethodTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/**
 * @description
 * Permissions for administrators and customers. Used to control access to
 * GraphQL resolvers via the {@link Allow} decorator.
 *
 * ## Understanding Permission.Owner
 *
 * `Permission.Owner` is a special permission which is used in some Vendure resolvers to indicate that that resolver should only
 * be accessible to the "owner" of that resource.
 *
 * For example, the Shop API `activeCustomer` query resolver should only return the Customer object for the "owner" of that Customer, i.e.
 * based on the activeUserId of the current session. As a result, the resolver code looks like this:
 *
 * @example
 * ```TypeScript
 * \@Query()
 * \@Allow(Permission.Owner)
 * async activeCustomer(\@Ctx() ctx: RequestContext): Promise<Customer | undefined> {
 *   const userId = ctx.activeUserId;
 *   if (userId) {
 *     return this.customerService.findOneByUserId(ctx, userId);
 *   }
 * }
 * ```
 *
 * Here we can see that the "ownership" must be enforced by custom logic inside the resolver. Since "ownership" cannot be defined generally
 * nor statically encoded at build-time, any resolvers using `Permission.Owner` **must** include logic to enforce that only the owner
 * of the resource has access. If not, then it is the equivalent of using `Permission.Public`.
 *
 *
 * @docsCategory common
 */
export enum Permission {
  /** Permission to access the contact persons */
  AccessContactPerson = 'AccessContactPerson',
  /** Authenticated means simply that the user is logged in */
  Authenticated = 'Authenticated',
  /** Grants permission to create Administrator */
  CreateAdministrator = 'CreateAdministrator',
  /** Grants permission to create AllCompanies */
  CreateAllCompanies = 'CreateAllCompanies',
  /** Grants permission to create AllOrganizations */
  CreateAllOrganizations = 'CreateAllOrganizations',
  /** Grants permission to create Asset */
  CreateAsset = 'CreateAsset',
  /** Grants permission to create Products, Facets, Assets, Collections */
  CreateCatalog = 'CreateCatalog',
  /** Grants permission to create Channel */
  CreateChannel = 'CreateChannel',
  /** Grants permission to create Collection */
  CreateCollection = 'CreateCollection',
  /** Grants permission to create Country */
  CreateCountry = 'CreateCountry',
  /** Grants permission to create Customer */
  CreateCustomer = 'CreateCustomer',
  /** Grants permission to create CustomerGroup */
  CreateCustomerGroup = 'CreateCustomerGroup',
  /** Grants permission to create Facet */
  CreateFacet = 'CreateFacet',
  /** Grants permission to create Order */
  CreateOrder = 'CreateOrder',
  /** Grants permission to create OwnCompany */
  CreateOwnCompany = 'CreateOwnCompany',
  /** Grants permission to create OwnOrganization */
  CreateOwnOrganization = 'CreateOwnOrganization',
  /** Grants permission to create PaymentMethod */
  CreatePaymentMethod = 'CreatePaymentMethod',
  /** Grants permission to create Product */
  CreateProduct = 'CreateProduct',
  /** Grants permission to create Promotion */
  CreatePromotion = 'CreatePromotion',
  /** Grants permission to create Seller */
  CreateSeller = 'CreateSeller',
  /** Grants permission to create PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  CreateSettings = 'CreateSettings',
  /** Grants permission to create ShippingMethod */
  CreateShippingMethod = 'CreateShippingMethod',
  /** Grants permission to create StockLocation */
  CreateStockLocation = 'CreateStockLocation',
  /** Grants permission to create System */
  CreateSystem = 'CreateSystem',
  /** Grants permission to create Tag */
  CreateTag = 'CreateTag',
  /** Grants permission to create TaxCategory */
  CreateTaxCategory = 'CreateTaxCategory',
  /** Grants permission to create TaxRate */
  CreateTaxRate = 'CreateTaxRate',
  /** Grants permission to create Zone */
  CreateZone = 'CreateZone',
  /** Enables configuration & curation of advanced search */
  CurateSearch = 'CurateSearch',
  /** Grants permission to delete Administrator */
  DeleteAdministrator = 'DeleteAdministrator',
  /** Grants permission to delete AllCompanies */
  DeleteAllCompanies = 'DeleteAllCompanies',
  /** Grants permission to delete AllOrganizations */
  DeleteAllOrganizations = 'DeleteAllOrganizations',
  /** Grants permission to delete Asset */
  DeleteAsset = 'DeleteAsset',
  /** Grants permission to delete Products, Facets, Assets, Collections */
  DeleteCatalog = 'DeleteCatalog',
  /** Grants permission to delete Channel */
  DeleteChannel = 'DeleteChannel',
  /** Grants permission to delete Collection */
  DeleteCollection = 'DeleteCollection',
  /** Grants permission to delete Country */
  DeleteCountry = 'DeleteCountry',
  /** Grants permission to delete Customer */
  DeleteCustomer = 'DeleteCustomer',
  /** Grants permission to delete CustomerGroup */
  DeleteCustomerGroup = 'DeleteCustomerGroup',
  /** Grants permission to delete Facet */
  DeleteFacet = 'DeleteFacet',
  /** Grants permission to delete Order */
  DeleteOrder = 'DeleteOrder',
  /** Grants permission to delete OwnCompany */
  DeleteOwnCompany = 'DeleteOwnCompany',
  /** Grants permission to delete OwnOrganization */
  DeleteOwnOrganization = 'DeleteOwnOrganization',
  /** Grants permission to delete PaymentMethod */
  DeletePaymentMethod = 'DeletePaymentMethod',
  /** Grants permission to delete Product */
  DeleteProduct = 'DeleteProduct',
  /** Grants permission to delete Promotion */
  DeletePromotion = 'DeletePromotion',
  /** Grants permission to delete Seller */
  DeleteSeller = 'DeleteSeller',
  /** Grants permission to delete PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  DeleteSettings = 'DeleteSettings',
  /** Grants permission to delete ShippingMethod */
  DeleteShippingMethod = 'DeleteShippingMethod',
  /** Grants permission to delete StockLocation */
  DeleteStockLocation = 'DeleteStockLocation',
  /** Grants permission to delete System */
  DeleteSystem = 'DeleteSystem',
  /** Grants permission to delete Tag */
  DeleteTag = 'DeleteTag',
  /** Grants permission to delete TaxCategory */
  DeleteTaxCategory = 'DeleteTaxCategory',
  /** Grants permission to delete TaxRate */
  DeleteTaxRate = 'DeleteTaxRate',
  /** Grants permission to delete Zone */
  DeleteZone = 'DeleteZone',
  /** Owner means the user owns this entity, e.g. a Customer's own Order */
  Owner = 'Owner',
  /** Public means any unauthenticated user may perform the operation */
  Public = 'Public',
  /** Grants permission to read Administrator */
  ReadAdministrator = 'ReadAdministrator',
  /** Grants permission to read AllCompanies */
  ReadAllCompanies = 'ReadAllCompanies',
  /** Grants permission to read AllOrganizations */
  ReadAllOrganizations = 'ReadAllOrganizations',
  /** Grants permission to read Asset */
  ReadAsset = 'ReadAsset',
  /** Grants permission to read Products, Facets, Assets, Collections */
  ReadCatalog = 'ReadCatalog',
  /** Grants permission to read Channel */
  ReadChannel = 'ReadChannel',
  /** Grants permission to read Collection */
  ReadCollection = 'ReadCollection',
  /** Grants permission to read Country */
  ReadCountry = 'ReadCountry',
  /** Grants permission to read Customer */
  ReadCustomer = 'ReadCustomer',
  /** Grants permission to read CustomerGroup */
  ReadCustomerGroup = 'ReadCustomerGroup',
  /** Grants permission to read Facet */
  ReadFacet = 'ReadFacet',
  /** Grants permission to read Order */
  ReadOrder = 'ReadOrder',
  /** Grants permission to read OwnCompany */
  ReadOwnCompany = 'ReadOwnCompany',
  /** Grants permission to read OwnOrganization */
  ReadOwnOrganization = 'ReadOwnOrganization',
  /** Grants permission to read PaymentMethod */
  ReadPaymentMethod = 'ReadPaymentMethod',
  /** Grants permission to read Product */
  ReadProduct = 'ReadProduct',
  /** Grants permission to read Promotion */
  ReadPromotion = 'ReadPromotion',
  /** Grants permission to read Seller */
  ReadSeller = 'ReadSeller',
  /** Grants permission to read PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  ReadSettings = 'ReadSettings',
  /** Grants permission to read ShippingMethod */
  ReadShippingMethod = 'ReadShippingMethod',
  /** Grants permission to read StockLocation */
  ReadStockLocation = 'ReadStockLocation',
  /** Grants permission to read System */
  ReadSystem = 'ReadSystem',
  /** Grants permission to read Tag */
  ReadTag = 'ReadTag',
  /** Grants permission to read TaxCategory */
  ReadTaxCategory = 'ReadTaxCategory',
  /** Grants permission to read TaxRate */
  ReadTaxRate = 'ReadTaxRate',
  /** Grants permission to read Zone */
  ReadZone = 'ReadZone',
  /** SuperAdmin has unrestricted access to all operations */
  SuperAdmin = 'SuperAdmin',
  /** Grants permission to update Administrator */
  UpdateAdministrator = 'UpdateAdministrator',
  /** Grants permission to update AllCompanies */
  UpdateAllCompanies = 'UpdateAllCompanies',
  /** Grants permission to update AllOrganizations */
  UpdateAllOrganizations = 'UpdateAllOrganizations',
  /** Grants permission to update Asset */
  UpdateAsset = 'UpdateAsset',
  /** Grants permission to update Products, Facets, Assets, Collections */
  UpdateCatalog = 'UpdateCatalog',
  /** Grants permission to update Channel */
  UpdateChannel = 'UpdateChannel',
  /** Grants permission to update Collection */
  UpdateCollection = 'UpdateCollection',
  /** Grants permission to update Country */
  UpdateCountry = 'UpdateCountry',
  /** Grants permission to update Customer */
  UpdateCustomer = 'UpdateCustomer',
  /** Grants permission to update CustomerGroup */
  UpdateCustomerGroup = 'UpdateCustomerGroup',
  /** Grants permission to update Facet */
  UpdateFacet = 'UpdateFacet',
  /** Grants permission to update GlobalSettings */
  UpdateGlobalSettings = 'UpdateGlobalSettings',
  /** Grants permission to update Order */
  UpdateOrder = 'UpdateOrder',
  /** Grants permission to update OwnCompany */
  UpdateOwnCompany = 'UpdateOwnCompany',
  /** Grants permission to update OwnOrganization */
  UpdateOwnOrganization = 'UpdateOwnOrganization',
  /** Grants permission to update PaymentMethod */
  UpdatePaymentMethod = 'UpdatePaymentMethod',
  /** Grants permission to update Product */
  UpdateProduct = 'UpdateProduct',
  /** Grants permission to update Promotion */
  UpdatePromotion = 'UpdatePromotion',
  /** Grants permission to update Seller */
  UpdateSeller = 'UpdateSeller',
  /** Grants permission to update PaymentMethods, ShippingMethods, TaxCategories, TaxRates, Zones, Countries, System & GlobalSettings */
  UpdateSettings = 'UpdateSettings',
  /** Grants permission to update ShippingMethod */
  UpdateShippingMethod = 'UpdateShippingMethod',
  /** Grants permission to update StockLocation */
  UpdateStockLocation = 'UpdateStockLocation',
  /** Grants permission to update System */
  UpdateSystem = 'UpdateSystem',
  /** Grants permission to update Tag */
  UpdateTag = 'UpdateTag',
  /** Grants permission to update TaxCategory */
  UpdateTaxCategory = 'UpdateTaxCategory',
  /** Grants permission to update TaxRate */
  UpdateTaxRate = 'UpdateTaxRate',
  /** Grants permission to update Zone */
  UpdateZone = 'UpdateZone'
}

export type PimcoreObjectsResult = {
  __typename?: 'PimcoreObjectsResult';
  collections?: Maybe<Array<Maybe<Collection>>>;
  productVariants?: Maybe<Array<Maybe<ProductVariant>>>;
  products?: Maybe<Array<Maybe<Product>>>;
};

/** The price range where the result has more than one price */
export type PriceRange = {
  __typename?: 'PriceRange';
  max: Scalars['Money']['output'];
  min: Scalars['Money']['output'];
};

export type PriceRangeInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type Product = Node & {
  __typename?: 'Product';
  assets: Array<Asset>;
  collections: Array<Collection>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<ProductCustomFields>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  facetValues: Array<FacetValue>;
  featuredAsset?: Maybe<Asset>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  optionGroups: Array<ProductOptionGroup>;
  slug: Scalars['String']['output'];
  translations: Array<ProductTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  /** Returns a paginated, sortable, filterable list of ProductVariants */
  variantList: ProductVariantList;
  /** Returns all ProductVariants */
  variants: Array<ProductVariant>;
};


export type ProductVariantListArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
};

export type ProductCustomFields = {
  __typename?: 'ProductCustomFields';
  additionalProducts?: Maybe<Array<Product>>;
  classification?: Maybe<Array<Block>>;
  customAttributes?: Maybe<Array<Block>>;
  downloads?: Maybe<Array<Download>>;
  infoText?: Maybe<Scalars['String']['output']>;
  onSiteImages?: Maybe<Array<Asset>>;
  pimcoreId?: Maybe<Scalars['Int']['output']>;
  productDetailName?: Maybe<Scalars['String']['output']>;
  systemInformationItems?: Maybe<Array<Block>>;
  systemLine?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
};

export type ProductFilterParameter = {
  _and?: InputMaybe<Array<ProductFilterParameter>>;
  _or?: InputMaybe<Array<ProductFilterParameter>>;
  createdAt?: InputMaybe<DateOperators>;
  description?: InputMaybe<StringOperators>;
  enabled?: InputMaybe<BooleanOperators>;
  id?: InputMaybe<IdOperators>;
  infoText?: InputMaybe<StringOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  pimcoreId?: InputMaybe<NumberOperators>;
  productDetailName?: InputMaybe<StringOperators>;
  slug?: InputMaybe<StringOperators>;
  systemLine?: InputMaybe<StringOperators>;
  systemName?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ProductList = PaginatedList & {
  __typename?: 'ProductList';
  items: Array<Product>;
  totalItems: Scalars['Int']['output'];
};

export type ProductListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductOption = Node & {
  __typename?: 'ProductOption';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  group: ProductOptionGroup;
  groupId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<ProductOptionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroup = Node & {
  __typename?: 'ProductOptionGroup';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  options: Array<ProductOption>;
  translations: Array<ProductOptionGroupTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionGroupTranslation = {
  __typename?: 'ProductOptionGroupTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductOptionTranslation = {
  __typename?: 'ProductOptionTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductSortParameter = {
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  infoText?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pimcoreId?: InputMaybe<SortOrder>;
  productDetailName?: InputMaybe<SortOrder>;
  slug?: InputMaybe<SortOrder>;
  systemLine?: InputMaybe<SortOrder>;
  systemName?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductTranslation = {
  __typename?: 'ProductTranslation';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<ProductTranslationCustomFields>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductTranslationCustomFields = {
  __typename?: 'ProductTranslationCustomFields';
  infoText?: Maybe<Scalars['String']['output']>;
  productDetailName?: Maybe<Scalars['String']['output']>;
  systemLine?: Maybe<Scalars['String']['output']>;
};

export type ProductVariant = Node & {
  __typename?: 'ProductVariant';
  appearsInWishlists: Array<ProductVariantWishlistData>;
  assets: Array<Asset>;
  createdAt: Scalars['DateTime']['output'];
  currencyCode: CurrencyCode;
  customFields?: Maybe<ProductVariantCustomFields>;
  facetValues: Array<FacetValue>;
  featuredAsset?: Maybe<Asset>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  options: Array<ProductOption>;
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  product: Product;
  productId: Scalars['ID']['output'];
  sku: Scalars['String']['output'];
  stockLevel: Scalars['String']['output'];
  taxCategory: TaxCategory;
  taxRateApplied: TaxRate;
  translations: Array<ProductVariantTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductVariantCustomFields = {
  __typename?: 'ProductVariantCustomFields';
  additionalProducts?: Maybe<Array<Product>>;
  categoryHierarchy?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Array<Block>>;
  customAttributes?: Maybe<Array<Block>>;
  downloads?: Maybe<Array<Download>>;
  infoText?: Maybe<Scalars['String']['output']>;
  onSiteImages?: Maybe<Array<Asset>>;
  pimcoreId?: Maybe<Scalars['Int']['output']>;
  productDetailName?: Maybe<Scalars['String']['output']>;
  productGroupDiscount?: Maybe<Scalars['String']['output']>;
  systemInformationItems?: Maybe<Array<Block>>;
  systemLine?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantFilterParameter = {
  _and?: InputMaybe<Array<ProductVariantFilterParameter>>;
  _or?: InputMaybe<Array<ProductVariantFilterParameter>>;
  categoryHierarchy?: InputMaybe<StringOperators>;
  createdAt?: InputMaybe<DateOperators>;
  currencyCode?: InputMaybe<StringOperators>;
  id?: InputMaybe<IdOperators>;
  infoText?: InputMaybe<StringOperators>;
  languageCode?: InputMaybe<StringOperators>;
  name?: InputMaybe<StringOperators>;
  pimcoreId?: InputMaybe<NumberOperators>;
  price?: InputMaybe<NumberOperators>;
  priceWithTax?: InputMaybe<NumberOperators>;
  productDetailName?: InputMaybe<StringOperators>;
  productGroupDiscount?: InputMaybe<StringOperators>;
  productId?: InputMaybe<IdOperators>;
  sku?: InputMaybe<StringOperators>;
  stockLevel?: InputMaybe<StringOperators>;
  systemLine?: InputMaybe<StringOperators>;
  systemName?: InputMaybe<StringOperators>;
  updatedAt?: InputMaybe<DateOperators>;
};

export type ProductVariantList = PaginatedList & {
  __typename?: 'ProductVariantList';
  items: Array<ProductVariant>;
  totalItems: Scalars['Int']['output'];
};

export type ProductVariantListOptions = {
  /** Allows the results to be filtered */
  filter?: InputMaybe<ProductVariantFilterParameter>;
  /** Specifies whether multiple top-level "filter" fields should be combined with a logical AND or OR operation. Defaults to AND. */
  filterOperator?: InputMaybe<LogicalOperator>;
  /** Skips the first n results, for use in pagination */
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Specifies which properties to sort the results by */
  sort?: InputMaybe<ProductVariantSortParameter>;
  /** Takes n results, for use in pagination */
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type ProductVariantSortParameter = {
  categoryHierarchy?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  infoText?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  pimcoreId?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  priceWithTax?: InputMaybe<SortOrder>;
  productDetailName?: InputMaybe<SortOrder>;
  productGroupDiscount?: InputMaybe<SortOrder>;
  productId?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  stockLevel?: InputMaybe<SortOrder>;
  systemLine?: InputMaybe<SortOrder>;
  systemName?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ProductVariantTranslation = {
  __typename?: 'ProductVariantTranslation';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<ProductVariantTranslationCustomFields>;
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductVariantTranslationCustomFields = {
  __typename?: 'ProductVariantTranslationCustomFields';
  categoryHierarchy?: Maybe<Scalars['String']['output']>;
  infoText?: Maybe<Scalars['String']['output']>;
  productDetailName?: Maybe<Scalars['String']['output']>;
  systemLine?: Maybe<Scalars['String']['output']>;
};

export type ProductVariantWishlistData = {
  __typename?: 'ProductVariantWishlistData';
  addedAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  variantId: Scalars['ID']['output'];
};

export type Promotion = Node & {
  __typename?: 'Promotion';
  actions: Array<ConfigurableOperation>;
  conditions: Array<ConfigurableOperation>;
  couponCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  enabled: Scalars['Boolean']['output'];
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  perCustomerUsageLimit?: Maybe<Scalars['Int']['output']>;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  translations: Array<PromotionTranslation>;
  updatedAt: Scalars['DateTime']['output'];
  usageLimit?: Maybe<Scalars['Int']['output']>;
};

export type PromotionList = PaginatedList & {
  __typename?: 'PromotionList';
  items: Array<Promotion>;
  totalItems: Scalars['Int']['output'];
};

export type PromotionTranslation = {
  __typename?: 'PromotionTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Province = Node & Region & {
  __typename?: 'Province';
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProvinceList = PaginatedList & {
  __typename?: 'ProvinceList';
  items: Array<Province>;
  totalItems: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  /** The active Channel */
  activeChannel: Channel;
  activeCompany?: Maybe<Company>;
  /** The active Customer */
  activeCustomer?: Maybe<Customer>;
  /**
   * The active Order. Will be `null` until an Order is created via `addItemToOrder`. Once an Order reaches the
   * state of `PaymentAuthorized` or `PaymentSettled`, then that Order is no longer considered "active" and this
   * query will once again return `null`.
   */
  activeOrder?: Maybe<Order>;
  activeOrganization?: Maybe<Organization>;
  activeUserWishlist?: Maybe<Wishlist>;
  activeUserWishlists: Array<Wishlist>;
  /** An array of supported Countries */
  availableCountries: Array<Country>;
  channel: GetChannelResult;
  /** Returns a Collection either by its id or slug. If neither 'id' nor 'slug' is specified, an error will result. */
  collection?: Maybe<Collection>;
  /** A list of Collections available to the shop */
  collections: CollectionList;
  companies?: Maybe<CompanyList>;
  company?: Maybe<Company>;
  companyCustomers?: Maybe<CompanyCustomersResult>;
  contactPerson?: Maybe<ContactPerson>;
  customerSpecificPrice?: Maybe<CustomerSpecificPrice>;
  /** Returns a list of payment methods and their eligibility based on the current active Order */
  eligiblePaymentMethods: Array<PaymentMethodQuote>;
  /** Returns a list of eligible shipping methods based on the current active Order */
  eligibleShippingMethods: Array<ShippingMethodQuote>;
  /** Returns a Facet by its id */
  facet?: Maybe<Facet>;
  /** A list of Facets available to the shop */
  facets: FacetList;
  kpis?: Maybe<Kpis>;
  /** Returns information about the current authenticated User */
  me?: Maybe<CurrentUser>;
  /** Returns the possible next states that the activeOrder can transition to */
  nextOrderStates: Array<Scalars['String']['output']>;
  offerById?: Maybe<Offer>;
  offerPrices?: Maybe<OfferPriceList>;
  offerSettings?: Maybe<OfferSettings>;
  offers?: Maybe<Array<Offer>>;
  /**
   * Returns an Order based on the id. Note that in the Shop API, only orders belonging to the
   * currently-authenticated User may be queried.
   */
  order?: Maybe<Order>;
  orderAssets?: Maybe<Array<Asset>>;
  /**
   * Returns an Order based on the order `code`. For guest Orders (i.e. Orders placed by non-authenticated Customers)
   * this query will only return the Order within 2 hours of the Order being placed. This allows an Order confirmation
   * screen to be shown immediately after completion of a guest checkout, yet prevents security risks of allowing
   * general anonymous access to Order data.
   */
  orderByCode?: Maybe<Order>;
  orderDocuments?: Maybe<OrderDocumentList>;
  pimcoreObjects: PimcoreObjectsResult;
  /** Get a Product either by id or slug. If neither 'id' nor 'slug' is specified, an error will result. */
  product?: Maybe<Product>;
  /** Get a list of Products */
  products: ProductList;
  promotions: Array<Promotion>;
  publicWishlist?: Maybe<Wishlist>;
  /** Search Products based on the criteria set by the `SearchInput` */
  search: SearchResponse;
  variant?: Maybe<ProductVariant>;
  /**
   * Returns additional products for a variant, filtering out soft-deleted products
   * and products without active variants
   */
  variantAdditionalProducts: Array<Product>;
  variants: Array<ProductVariant>;
};


export type QueryActiveOrderArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
};


export type QueryActiveUserWishlistArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryChannelArgs = {
  countryCode: Scalars['String']['input'];
};


export type QueryCollectionArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCollectionsArgs = {
  options?: InputMaybe<CollectionListOptions>;
};


export type QueryCompaniesArgs = {
  options?: InputMaybe<CompanyListOptions>;
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCompanyCustomersArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  options?: InputMaybe<CompanyListOptions>;
};


export type QueryContactPersonArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCustomerSpecificPriceArgs = {
  channelCode: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
};


export type QueryEligiblePaymentMethodsArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
};


export type QueryEligibleShippingMethodsArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
};


export type QueryFacetArgs = {
  id: Scalars['ID']['input'];
};


export type QueryFacetsArgs = {
  options?: InputMaybe<FacetListOptions>;
};


export type QueryNextOrderStatesArgs = {
  activeOrderInput?: InputMaybe<ActiveOrderInput>;
};


export type QueryOfferByIdArgs = {
  offerId: Scalars['ID']['input'];
};


export type QueryOfferPricesArgs = {
  options?: InputMaybe<OfferPriceListOptions>;
  productVariantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOffersArgs = {
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  options?: InputMaybe<OfferListOptions>;
  status?: InputMaybe<OfferStatus>;
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOrderByCodeArgs = {
  code: Scalars['String']['input'];
};


export type QueryOrderDocumentsArgs = {
  options?: InputMaybe<OrderDocumentListOptions>;
};


export type QueryPimcoreObjectsArgs = {
  ids: Array<Scalars['Int']['input']>;
};


export type QueryProductArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};


export type QueryProductsArgs = {
  options?: InputMaybe<ProductListOptions>;
};


export type QueryPromotionsArgs = {
  productIds?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};


export type QueryPublicWishlistArgs = {
  publicCode: Scalars['String']['input'];
};


export type QuerySearchArgs = {
  input: SearchInput;
};


export type QueryVariantArgs = {
  variantId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVariantAdditionalProductsArgs = {
  variantId: Scalars['ID']['input'];
};


export type QueryVariantsArgs = {
  options?: InputMaybe<ProductVariantListOptions>;
  skus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type RefreshCustomerVerificationResult = NativeAuthStrategyError | Success;

export type Refund = Node & {
  __typename?: 'Refund';
  adjustment: Scalars['Money']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  items: Scalars['Money']['output'];
  lines: Array<RefundLine>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  method?: Maybe<Scalars['String']['output']>;
  paymentId: Scalars['ID']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  shipping: Scalars['Money']['output'];
  state: Scalars['String']['output'];
  total: Scalars['Money']['output'];
  transactionId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RefundLine = {
  __typename?: 'RefundLine';
  orderLine: OrderLine;
  orderLineId: Scalars['ID']['output'];
  quantity: Scalars['Int']['output'];
  refund: Refund;
  refundId: Scalars['ID']['output'];
};

export type Region = {
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  parent?: Maybe<Region>;
  parentId?: Maybe<Scalars['ID']['output']>;
  translations: Array<RegionTranslation>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegionTranslation = {
  __typename?: 'RegionTranslation';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type RegisterB2BCustomerAccountResult = InvalidVatError | MissingPasswordError | NativeAuthStrategyError | PasswordValidationError | Success;

export type RegisterCompanyInput = {
  address: CreateCompanyAddressInput;
  name: Scalars['String']['input'];
  organization?: InputMaybe<RegisterCompanyOrganizationInput>;
};

export type RegisterCompanyOrganizationInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterCustomerAccountResult = MissingPasswordError | NativeAuthStrategyError | PasswordValidationError | Success;

export type RegisterCustomerCustomFieldsInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyRolesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterCustomerInput = {
  customFields?: InputMaybe<RegisterCustomerCustomFieldsInput>;
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type RelationCustomFieldConfig = CustomField & {
  __typename?: 'RelationCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  entity: Scalars['String']['output'];
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  scalarFields: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type RemoveOrderItemsResult = Order | OrderInterceptorError | OrderModificationError;

export type Request = {
  __typename?: 'Request';
  requested: Scalars['Boolean']['output'];
};

export type RequestPasswordResetResult = NativeAuthStrategyError | Success;

export type RequestUpdateCustomerEmailAddressResult = EmailAddressConflictError | InvalidCredentialsError | NativeAuthStrategyError | Success;

export type ResetPasswordResult = CurrentUser | NativeAuthStrategyError | NotVerifiedError | PasswordResetTokenExpiredError | PasswordResetTokenInvalidError | PasswordValidationError;

export type ResultHighlight = {
  __typename?: 'ResultHighlight';
  field: Scalars['String']['output'];
  matchedTokens: Array<Scalars['String']['output']>;
  snippet: Scalars['String']['output'];
};

export type Role = Node & {
  __typename?: 'Role';
  channels: Array<Channel>;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  permissions: Array<Permission>;
  updatedAt: Scalars['DateTime']['output'];
};

export type RoleList = PaginatedList & {
  __typename?: 'RoleList';
  items: Array<Role>;
  totalItems: Scalars['Int']['output'];
};

export type SearchInput = {
  /** Whether to apply curations to the results */
  applyCurations?: InputMaybe<Scalars['Boolean']['input']>;
  collectionId?: InputMaybe<Scalars['ID']['input']>;
  collectionSlug?: InputMaybe<Scalars['String']['input']>;
  facetValueFilters?: InputMaybe<Array<FacetValueFilterInput>>;
  /** Allows filtering by facetCode and facetValueCodes to get a subset of facets in the facets object of the response to easily further refine the search */
  facetsFilter?: InputMaybe<FacetsFilterInput>;
  /** Supply custom Typesense filter strings to apply to the search */
  filterBy?: InputMaybe<Array<Scalars['String']['input']>>;
  groupByProduct?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allows filtering by stock status */
  inStock?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to log this search in the analytics store. If true, the result will include a queryId */
  logAnalytics?: InputMaybe<Scalars['Boolean']['input']>;
  maxFacetValues?: InputMaybe<Scalars['Int']['input']>;
  /** If true, will use the search term as a prefix. Intended in live search (autocomplete) use cases. */
  prefixMode?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allows filtering by price range */
  priceRange?: InputMaybe<PriceRangeInput>;
  /** Allows filtering by price range (including taxes) */
  priceRangeWithTax?: InputMaybe<PriceRangeInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<SearchResultSortParameter>;
  /** Supply custom Typesense sort strings to apply to the search */
  sortBy?: InputMaybe<Array<Scalars['String']['input']>>;
  take?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  /** Specify the text_match_type parameter that gets used by Typesense to rank the scores for the results. */
  textMatchType?: InputMaybe<TextMatchType>;
  /** Sample to top collections from the first n results, defaults to 10 */
  topCollectionsFromTop?: InputMaybe<Scalars['Int']['input']>;
};

export type SearchListViewedEventInput = {
  queryId: Scalars['String']['input'];
};

export type SearchReindexResponse = {
  __typename?: 'SearchReindexResponse';
  success: Scalars['Boolean']['output'];
};

export type SearchResponse = {
  __typename?: 'SearchResponse';
  collections: Array<CollectionResult>;
  facetCounts: Array<FacetCountData>;
  facetValues: Array<FacetValueResult>;
  facets: Array<FacetResult>;
  items: Array<SearchResult>;
  prices: SearchResponsePriceData;
  queryId?: Maybe<Scalars['String']['output']>;
  topCollections: Array<Maybe<TopCollectionResult>>;
  totalItems: Scalars['Int']['output'];
};

export type SearchResponsePriceData = {
  __typename?: 'SearchResponsePriceData';
  range: PriceRange;
  rangeWithTax: PriceRange;
};

export type SearchResult = {
  __typename?: 'SearchResult';
  /** An array of ids of the Collections in which this result appears */
  collectionIds: Array<Scalars['ID']['output']>;
  collectionSlugs: Array<Scalars['String']['output']>;
  currencyCode: CurrencyCode;
  customMappings: SearchResultCustomMappings;
  description: Scalars['String']['output'];
  facetIds: Array<Scalars['ID']['output']>;
  facetValueIds: Array<Scalars['ID']['output']>;
  geoDistance?: Maybe<Array<GeoDistance>>;
  highlights: Array<ResultHighlight>;
  id: Scalars['String']['output'];
  inStock: Scalars['Boolean']['output'];
  price: SearchResultPrice;
  priceWithTax: SearchResultPrice;
  productAsset?: Maybe<SearchResultAsset>;
  productId: Scalars['ID']['output'];
  productName: Scalars['String']['output'];
  productVariantAsset?: Maybe<SearchResultAsset>;
  productVariantId: Scalars['ID']['output'];
  productVariantName: Scalars['String']['output'];
  /** A relevance score for the result. Differs between database implementations */
  score: Scalars['Float']['output'];
  sku: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type SearchResultAsset = {
  __typename?: 'SearchResultAsset';
  focalPoint?: Maybe<Coordinate>;
  id: Scalars['ID']['output'];
  preview: Scalars['String']['output'];
};

export type SearchResultClickedEventInput = {
  position: Scalars['Int']['input'];
  queryId: Scalars['String']['input'];
  resultId: Scalars['String']['input'];
};

export type SearchResultCustomMappings = {
  __typename?: 'SearchResultCustomMappings';
  allVariantOptions: Scalars['String']['output'];
  classification?: Maybe<Scalars['String']['output']>;
  collectionBreadcrumbslvl0: Scalars['String']['output'];
  collectionBreadcrumbslvl1: Scalars['String']['output'];
  collectionBreadcrumbslvl2: Scalars['String']['output'];
  collectionBreadcrumbslvl3: Scalars['String']['output'];
  diameterMax?: Maybe<Scalars['Int']['output']>;
  diameterMin?: Maybe<Scalars['Int']['output']>;
  facets: Array<Scalars['String']['output']>;
  sortIndex: Scalars['Int']['output'];
  sortName: Scalars['String']['output'];
  systemLine?: Maybe<Scalars['String']['output']>;
  systemName?: Maybe<Scalars['String']['output']>;
};

/** The price of a search result product, either as a range or as a single price */
export type SearchResultPrice = PriceRange | SinglePrice;

export type SearchResultSortParameter = {
  name?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  productVariantId?: InputMaybe<SortOrder>;
  sku?: InputMaybe<SortOrder>;
  sortIndex?: InputMaybe<SortOrder>;
  sortName?: InputMaybe<SortOrder>;
};

export type Seller = Node & {
  __typename?: 'Seller';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type SetActiveCompanyResult = Customer | EntityNotFoundError | NotAllowedError;

export type SetCustomerForOrderResult = AlreadyLoggedInError | EmailAddressConflictError | GuestCheckoutError | NoActiveOrderError | Order;

export type SetOrderPaymentMethodResult = IneligiblePaymentMethodError | NoActiveOrderError | Order | OrderPaymentStateError;

export type SetOrderShippingMethodResult = IneligibleShippingMethodError | NoActiveOrderError | Order | OrderModificationError;

export type ShippingLine = {
  __typename?: 'ShippingLine';
  customFields?: Maybe<Scalars['JSON']['output']>;
  discountedPrice: Scalars['Money']['output'];
  discountedPriceWithTax: Scalars['Money']['output'];
  discounts: Array<Discount>;
  id: Scalars['ID']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  shippingMethod: ShippingMethod;
};

export type ShippingMethod = Node & {
  __typename?: 'ShippingMethod';
  calculator: ConfigurableOperation;
  checker: ConfigurableOperation;
  code: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  fulfillmentHandlerCode: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  translations: Array<ShippingMethodTranslation>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ShippingMethodList = PaginatedList & {
  __typename?: 'ShippingMethodList';
  items: Array<ShippingMethod>;
  totalItems: Scalars['Int']['output'];
};

export type ShippingMethodQuote = {
  __typename?: 'ShippingMethodQuote';
  code: Scalars['String']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Any optional metadata returned by the ShippingCalculator in the ShippingCalculationResult */
  metadata?: Maybe<Scalars['JSON']['output']>;
  name: Scalars['String']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
};

export type ShippingMethodTranslation = {
  __typename?: 'ShippingMethodTranslation';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  languageCode: LanguageCode;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** The price value where the result has a single price */
export type SinglePrice = {
  __typename?: 'SinglePrice';
  value: Scalars['Money']['output'];
};

export enum SortOptions {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StringCustomFieldConfig = CustomField & {
  __typename?: 'StringCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  length?: Maybe<Scalars['Int']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<StringFieldOption>>;
  pattern?: Maybe<Scalars['String']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StringFieldOption = {
  __typename?: 'StringFieldOption';
  label?: Maybe<Array<LocalizedString>>;
  value: Scalars['String']['output'];
};

/** Operators for filtering on a list of String fields */
export type StringListOperators = {
  inList: Scalars['String']['input'];
};

/** Operators for filtering on a String field */
export type StringOperators = {
  contains?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  isNull?: InputMaybe<Scalars['Boolean']['input']>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notEq?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<Scalars['String']['input']>>;
  regex?: InputMaybe<Scalars['String']['input']>;
};

export type StringStructFieldConfig = StructField & {
  __typename?: 'StringStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  length?: Maybe<Scalars['Int']['output']>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  options?: Maybe<Array<StringFieldOption>>;
  pattern?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructCustomFieldConfig = CustomField & {
  __typename?: 'StructCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  fields: Array<StructFieldConfig>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructField = {
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type StructFieldConfig = BooleanStructFieldConfig | DateTimeStructFieldConfig | FloatStructFieldConfig | IntStructFieldConfig | StringStructFieldConfig | TextStructFieldConfig;

/** Indicates that an operation succeeded, where we do not want to return any more specific information. */
export type Success = {
  __typename?: 'Success';
  success: Scalars['Boolean']['output'];
};

export type Surcharge = Node & {
  __typename?: 'Surcharge';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  price: Scalars['Money']['output'];
  priceWithTax: Scalars['Money']['output'];
  sku?: Maybe<Scalars['String']['output']>;
  taxLines: Array<TaxLine>;
  taxRate: Scalars['Float']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Tag = Node & {
  __typename?: 'Tag';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['String']['output'];
};

export type TagList = PaginatedList & {
  __typename?: 'TagList';
  items: Array<Tag>;
  totalItems: Scalars['Int']['output'];
};

export type TaxCategory = Node & {
  __typename?: 'TaxCategory';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type TaxLine = {
  __typename?: 'TaxLine';
  description: Scalars['String']['output'];
  taxRate: Scalars['Float']['output'];
};

export type TaxRate = Node & {
  __typename?: 'TaxRate';
  category: TaxCategory;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  customerGroup?: Maybe<CustomerGroup>;
  enabled: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  value: Scalars['Float']['output'];
  zone: Zone;
};

export type TaxRateList = PaginatedList & {
  __typename?: 'TaxRateList';
  items: Array<TaxRate>;
  totalItems: Scalars['Int']['output'];
};

export type TermsOfPayment = Node & {
  __typename?: 'TermsOfPayment';
  amount?: Maybe<Scalars['Int']['output']>;
  companyId?: Maybe<Scalars['ID']['output']>;
  contactPerson?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  paymentId?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type TextCustomFieldConfig = CustomField & {
  __typename?: 'TextCustomFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  internal?: Maybe<Scalars['Boolean']['output']>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nullable?: Maybe<Scalars['Boolean']['output']>;
  readonly?: Maybe<Scalars['Boolean']['output']>;
  requiresPermission?: Maybe<Array<Permission>>;
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export enum TextMatchType {
  MaxScore = 'max_score',
  MaxWeight = 'max_weight',
  SumScore = 'sum_score'
}

export type TextStructFieldConfig = StructField & {
  __typename?: 'TextStructFieldConfig';
  description?: Maybe<Array<LocalizedString>>;
  label?: Maybe<Array<LocalizedString>>;
  list: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  ui?: Maybe<Scalars['JSON']['output']>;
};

export type ToggleCustomerSpecificPricesResult = EntityNotFoundError | Order;

export type TopCollectionResult = {
  __typename?: 'TopCollectionResult';
  collection: Collection;
  score: Scalars['Int']['output'];
};

export type TransformOfferToCartResult = EntityNotFoundError | Success;

export type TransitionOrderToStateResult = Order | OrderStateTransitionError;

export type UnauthorizedError = ErrorResult & {
  __typename?: 'UnauthorizedError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/**
 * Input used to update an Address.
 *
 * The countryCode must correspond to a `code` property of a Country that has been defined in the
 * Vendure server. The `code` property is typically a 2-character ISO code such as "GB", "US", "DE" etc.
 * If an invalid code is passed, the mutation will fail.
 */
export type UpdateAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  defaultBillingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  defaultShippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyAddressCustomFieldsInput = {
  erpId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyAddressInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  customFields?: InputMaybe<UpdateCompanyAddressCustomFieldsInput>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  province?: InputMaybe<Scalars['String']['input']>;
  streetLine1?: InputMaybe<Scalars['String']['input']>;
  streetLine2?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyAddressResult = CompanyAddress | EntityNotFoundError;

export type UpdateCompanyCustomFieldsInput = {
  erpId?: InputMaybe<Scalars['String']['input']>;
  isConfiguratorAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  ust?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInput = {
  customFields?: InputMaybe<UpdateCompanyCustomFieldsInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateCompanyResult = Company | EntityNotFoundError;

export type UpdateCompanyRoleInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
  isCompanyAgnostic?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyRoleResult = CompanyRole | EntityNotFoundError;

export type UpdateCompanyStatusInput = {
  status: CompanyStatus;
};

export type UpdateCompanyStatusResult = Company | EntityNotFoundError;

export type UpdateContactPersonInput = {
  absent?: InputMaybe<Scalars['Boolean']['input']>;
  absentFrom?: InputMaybe<Scalars['DateTime']['input']>;
  absentTo?: InputMaybe<Scalars['DateTime']['input']>;
  active?: InputMaybe<Scalars['Boolean']['input']>;
  department?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  fax?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  jobTitle?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  portrait?: InputMaybe<Scalars['String']['input']>;
  workHoursFrom?: InputMaybe<Scalars['String']['input']>;
  workHoursTo?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactPersonResult = ContactPerson | EntityNotFoundError | NotAllowedError;

export type UpdateCustomerCustomFieldsInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyRolesIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  employmentsIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerEmailAddressResult = IdentifierChangeTokenExpiredError | IdentifierChangeTokenInvalidError | NativeAuthStrategyError | Success;

export type UpdateCustomerInput = {
  customFields?: InputMaybe<UpdateCustomerCustomFieldsInput>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerPasswordResult = InvalidCredentialsError | NativeAuthStrategyError | PasswordValidationError | Success;

export type UpdateEmploymentInput = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  companyRoleId?: InputMaybe<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};

export type UpdateEmploymentResult = Employment | EntityNotFoundError;

export type UpdateOfferInput = {
  additionalDiscount?: InputMaybe<Scalars['Int']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  number?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<CreateOfferPositionInput>>;
  reference?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OfferStatus>;
  subject?: InputMaybe<Scalars['String']['input']>;
  termsOfDelivery?: InputMaybe<Scalars['String']['input']>;
  termsOfPayment?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOfferPriceInput = {
  offerPriceId: Scalars['ID']['input'];
  price: Scalars['Int']['input'];
};

export type UpdateOfferPriceResult = EntityNotFoundError | OfferPrice;

export type UpdateOfferResult = EntityNotFoundError | NotAllowedError | Offer;

export type UpdateOfferSettingsInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  companyRegister?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOfferSettingsResult = EntityNotFoundError | OfferSettings;

export type UpdateOfferStateInput = {
  offerId: Scalars['ID']['input'];
  status: OfferStatus;
};

export type UpdateOfferStateResult = EntityNotFoundError | Offer;

export type UpdateOrderCustomFieldsInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['ID']['input']>;
  erpId?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  savedPaymentMethod?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderDocumentInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrderDocumentResult = EntityNotFoundError | OrderDocument;

export type UpdateOrderInput = {
  customFields?: InputMaybe<UpdateOrderCustomFieldsInput>;
};

export type UpdateOrderItemsResult = InsufficientStockError | NegativeQuantityError | Order | OrderInterceptorError | OrderLimitError | OrderModificationError;

export type UpdateOrganizationInput = {
  customFields?: InputMaybe<Scalars['JSON']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOrganizationResult = DuplicateEntityError | EntityNotFoundError | Organization;

export type UpdateWishlistInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type User = Node & {
  __typename?: 'User';
  authenticationMethods: Array<AuthenticationMethod>;
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  identifier: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  roles: Array<Role>;
  updatedAt: Scalars['DateTime']['output'];
  verified: Scalars['Boolean']['output'];
};

/**
 * Returned if the verification token (used to verify a Customer's email address) is valid, but has
 * expired according to the `verificationTokenDuration` setting in the AuthOptions.
 */
export type VerificationTokenExpiredError = ErrorResult & {
  __typename?: 'VerificationTokenExpiredError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

/**
 * Returned if the verification token (used to verify a Customer's email address) is either
 * invalid or does not match any expected tokens.
 */
export type VerificationTokenInvalidError = ErrorResult & {
  __typename?: 'VerificationTokenInvalidError';
  errorCode: ErrorCode;
  message: Scalars['String']['output'];
};

export type VerifyCustomerAccountResult = CurrentUser | MissingPasswordError | NativeAuthStrategyError | PasswordAlreadySetError | PasswordValidationError | VerificationTokenExpiredError | VerificationTokenInvalidError;

export type VerifyCustomerResult = Customer | EntityNotFoundError;

export type Wishlist = Node & {
  __typename?: 'Wishlist';
  createdAt: Scalars['DateTime']['output'];
  customer?: Maybe<Customer>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  itemCount: Scalars['Int']['output'];
  items: Array<WishlistItem>;
  name: Scalars['String']['output'];
  publicCode?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type WishlistItem = Node & {
  __typename?: 'WishlistItem';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  lastPurchasedAt?: Maybe<Scalars['DateTime']['output']>;
  product: Product;
  productVariant: ProductVariant;
  productVariantId: Scalars['ID']['output'];
  purchased: Scalars['Boolean']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type Zone = Node & {
  __typename?: 'Zone';
  createdAt: Scalars['DateTime']['output'];
  customFields?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  members: Array<Region>;
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type AddressFragment = { __typename?: 'Address', id: string, createdAt: any, updatedAt: any, fullName?: string | null, streetLine1: string, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, customFields?: any | null, country: { __typename?: 'Country', id: string, languageCode: LanguageCode, code: string, name: string, enabled: boolean, customFields?: any | null } };

export type CompanyAddressFragment = { __typename?: 'CompanyAddress', id: string, fullName: string, streetLine1: string, streetLine2?: string | null, province?: string | null, countryCode?: string | null, city?: string | null, postalCode?: string | null, phoneNumber?: string | null, defaultBillingAddress: boolean, defaultShippingAddress: boolean, customFields?: { __typename?: 'CompanyAddressCustomFields', erpId?: string | null } | null };

export type AssetFragment = { __typename?: 'Asset', width: number, height: number, source: string };

export type BreadcrumbFragment = { __typename?: 'CollectionBreadcrumb', name: string, id: string, slug: string };

export type CountryFragment = { __typename?: 'Country', id: string, languageCode: LanguageCode, code: string, name: string, enabled: boolean, customFields?: any | null };

export type ActiveOrderFragment = { __typename?: 'Order', id: string, state: string, updatedAt: any, createdAt: any, total: any, totalWithTax: any, subTotal: any, subTotalWithTax: any, shipping: any, currencyCode: CurrencyCode, shippingWithTax: any, totalQuantity: number, lines: Array<{ __typename?: 'OrderLine', id: string, linePrice: any, discountedLinePrice: any, unitPrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', currencyCode: CurrencyCode, id: string, name: string, sku: string, price: any, assets: Array<{ __typename?: 'Asset', id: string, source: string }> } }> };

export type OrderAddressFragment = { __typename?: 'OrderAddress', fullName?: string | null, company?: string | null, streetLine1?: string | null, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null, phoneNumber?: string | null, customFields?: any | null };

export type ProductVariantCustomFieldFragment = { __typename?: 'ProductVariantCustomFields', productDetailName?: string | null, infoText?: string | null, systemName?: string | null, customAttributes?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, onSiteImages?: Array<{ __typename?: 'Asset', name: string, source: string }> | null, systemInformationItems?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, additionalProducts?: Array<{ __typename?: 'Product', id: string, name: string }> | null };

export type ProductVariantFragment = { __typename?: 'ProductVariant', id: string, name: string, sku: string, stockLevel: string, currencyCode: CurrencyCode, price: any, options: Array<{ __typename?: 'ProductOption', code: string, group: { __typename?: 'ProductOptionGroup', name: string } }>, facetValues: Array<{ __typename?: 'FacetValue', id: string, code: string, name: string }>, customFields?: { __typename?: 'ProductVariantCustomFields', pimcoreId?: number | null, productDetailName?: string | null, infoText?: string | null, systemName?: string | null, customAttributes?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, onSiteImages?: Array<{ __typename?: 'Asset', name: string, source: string }> | null, systemInformationItems?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, additionalProducts?: Array<{ __typename?: 'Product', id: string, name: string }> | null } | null, assets: Array<{ __typename?: 'Asset', width: number, height: number, source: string }> };

export type CustomerDataFragment = { __typename?: 'Customer', id: string, firstName: string, lastName: string, emailAddress: string, title?: string | null, phoneNumber?: string | null, customFields?: { __typename?: 'CustomerCustomFields', salutation?: string | null } | null };

export type AddItemToOrderMutationVariables = Exact<{
  productVariantId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
  withCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddItemToOrderMutation = { __typename?: 'Mutation', addItemToOrder: { __typename: 'InsufficientStockError', errorCode: ErrorCode, message: string, quantityAvailable: number } | { __typename: 'NegativeQuantityError', errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, state: string, customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string, emailAddress: string, title?: string | null, phoneNumber?: string | null, customFields?: { __typename?: 'CustomerCustomFields', salutation?: string | null } | null } | null } | { __typename: 'OrderInterceptorError' } | { __typename: 'OrderLimitError', message: string, maxItems: number } | { __typename: 'OrderModificationError', errorCode: ErrorCode, message: string } };

export type AddItemToOrderBySkuMutationVariables = Exact<{
  input: AddItemToOrderBySkuInput;
}>;


export type AddItemToOrderBySkuMutation = { __typename?: 'Mutation', addItemToOrderBySku: { __typename?: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename?: 'Order', id: string } };

export type AddPaymentMutationVariables = Exact<{
  input: PaymentInput;
}>;


export type AddPaymentMutation = { __typename?: 'Mutation', addPaymentToOrder: { __typename: 'IneligiblePaymentMethodError', errorCode: ErrorCode, message: string } | { __typename: 'NoActiveOrderError', errorCode: ErrorCode, message: string } | { __typename: 'Order', id: string, code: string, state: string, updatedAt: any, createdAt: any, total: any, totalWithTax: any, subTotal: any, subTotalWithTax: any, shipping: any, currencyCode: CurrencyCode, shippingWithTax: any, totalQuantity: number, lines: Array<{ __typename?: 'OrderLine', id: string, linePrice: any, discountedLinePrice: any, unitPrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', currencyCode: CurrencyCode, id: string, name: string, sku: string, price: any, assets: Array<{ __typename?: 'Asset', id: string, source: string }> } }> } | { __typename: 'OrderPaymentStateError', errorCode: ErrorCode, message: string } | { __typename: 'OrderStateTransitionError', errorCode: ErrorCode, message: string, transitionError: string, fromState: string, toState: string } | { __typename: 'PaymentDeclinedError', errorCode: ErrorCode, message: string, paymentErrorMessage: string } | { __typename: 'PaymentFailedError', errorCode: ErrorCode, message: string } };

export type AddToWishlistMutationVariables = Exact<{
  productVariantId: Scalars['ID']['input'];
  wishlistId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AddToWishlistMutation = { __typename?: 'Mutation', addToWishlist: { __typename?: 'Wishlist', id: string, itemCount: number, items: Array<{ __typename?: 'WishlistItem', id: string }> } };

export type UpdateCompanyAddressMutationVariables = Exact<{
  input: UpdateCompanyAddressInput;
}>;


export type UpdateCompanyAddressMutation = { __typename?: 'Mutation', updateCompanyAddress: { __typename: 'CompanyAddress', id: string } | { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } };

export type DeleteCompanyAddressMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteCompanyAddressMutation = { __typename?: 'Mutation', deleteCompanyAddress: { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type CreateCompanyAddressMutationVariables = Exact<{
  input: CreateCompanyAddressInput;
}>;


export type CreateCompanyAddressMutation = { __typename?: 'Mutation', addCompanyAddress: { __typename: 'CompanyAddress', id: string } | { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } };

export type AdjustOrderLineMutationVariables = Exact<{
  orderLineId: Scalars['ID']['input'];
  quantity: Scalars['Int']['input'];
}>;


export type AdjustOrderLineMutation = { __typename?: 'Mutation', adjustOrderLine: { __typename?: 'InsufficientStockError', errorCode: ErrorCode, message: string, quantityAvailable: number } | { __typename?: 'NegativeQuantityError', errorCode: ErrorCode, message: string } | { __typename?: 'Order', id: string, totalQuantity: number, lines: Array<{ __typename?: 'OrderLine', quantity: number }> } | { __typename?: 'OrderInterceptorError' } | { __typename?: 'OrderLimitError', errorCode: ErrorCode, message: string } | { __typename?: 'OrderModificationError', errorCode: ErrorCode, message: string } };

export type ApplyCouponCodeMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
}>;


export type ApplyCouponCodeMutation = { __typename?: 'Mutation', applyCouponCode: { __typename?: 'CouponCodeExpiredError', errorCode: ErrorCode, message: string, couponCode: string } | { __typename?: 'CouponCodeInvalidError', errorCode: ErrorCode, message: string, couponCode: string } | { __typename?: 'CouponCodeLimitError', errorCode: ErrorCode, message: string, couponCode: string, limit: number } | { __typename?: 'Order', id: string } };

export type CreateAddressMutationVariables = Exact<{
  city: Scalars['String']['input'];
  company: Scalars['String']['input'];
  countryCode: Scalars['String']['input'];
  fullName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  province: Scalars['String']['input'];
  streetLine1: Scalars['String']['input'];
  streetLine2: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
}>;


export type CreateAddressMutation = { __typename?: 'Mutation', createCustomerAddress: { __typename?: 'Address', id: string } };

export type CreateAssetMutationVariables = Exact<{
  input: Array<CreateAssetInput> | CreateAssetInput;
}>;


export type CreateAssetMutation = { __typename?: 'Mutation', createAssets: Array<{ __typename: 'Asset', id: string, preview: string, source: string } | { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'MimeTypeError', errorCode: ErrorCode, message: string, mimeType: string } | { __typename: 'NotAllowedError', errorCode: ErrorCode, message: string }> };

export type CreateCustomerAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type CreateCustomerAddressMutation = { __typename?: 'Mutation', createCustomerAddress: { __typename?: 'Address', id: string, createdAt: any } };

export type CreateOfferMutationVariables = Exact<{
  address: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  headerText: Scalars['String']['input'];
  footerText: Scalars['String']['input'];
  reference: Scalars['String']['input'];
  positions?: InputMaybe<Array<CreateOfferPositionInput> | CreateOfferPositionInput>;
  termsOfDelivery: Scalars['String']['input'];
  termsOfPayment: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  number: Scalars['String']['input'];
  additionalDiscount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CreateOfferMutation = { __typename?: 'Mutation', createOffer: { __typename: 'CustomerInputEmptyError', errorCode: ErrorCode, message: string } | { __typename: 'CustomerInputExistsError', errorCode: ErrorCode, message: string } | { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'NotAllowedError', errorCode: ErrorCode, message: string } | { __typename: 'Offer', id: string } };

export type CreateWishlistMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateWishlistMutation = { __typename?: 'Mutation', createWishlist: { __typename?: 'Wishlist', id: string, name: string } };

export type DeleteOfferMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOfferMutation = { __typename?: 'Mutation', deleteOffer: { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'NotAllowedError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type DeleteWishlistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteWishlistMutation = { __typename?: 'Mutation', deleteWishlist: { __typename?: 'DeletionResponse', result: DeletionResult, message?: string | null } };

export type LoginUserMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
  rememberMe: Scalars['Boolean']['input'];
}>;


export type LoginUserMutation = { __typename?: 'Mutation', login: { __typename: 'CurrentUser', id: string, identifier: string } | { __typename: 'InvalidCredentialsError', errorCode: ErrorCode, message: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'NotVerifiedError', errorCode: ErrorCode, message: string } };

export type LogoutUserMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutUserMutation = { __typename?: 'Mutation', logout: { __typename: 'Success', success: boolean } };

export type SubscribeToNewsletterMutationVariables = Exact<{
  input: NewsletterAddressInput;
}>;


export type SubscribeToNewsletterMutation = { __typename?: 'Mutation', subscribeToNewsletter: { __typename?: 'Success', success: boolean } };

export type UnsubscribeToNewsletterMutationVariables = Exact<{
  input: NewsletterAddressInput;
}>;


export type UnsubscribeToNewsletterMutation = { __typename?: 'Mutation', unsubscribeToNewsletter: { __typename?: 'Success', success: boolean } };

export type CreateOfferPriceMutationVariables = Exact<{
  productVariantId: Scalars['ID']['input'];
  offerPrice: Scalars['Int']['input'];
  currencyCode: Scalars['String']['input'];
}>;


export type CreateOfferPriceMutation = { __typename?: 'Mutation', createOfferPrice: { __typename?: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename?: 'OfferPrice', id: string, price: number } };

export type UpdateOfferPriceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  price: Scalars['Int']['input'];
}>;


export type UpdateOfferPriceMutation = { __typename?: 'Mutation', updateOfferPrice: { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'OfferPrice', id: string } };

export type DeleteOfferPriceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteOfferPriceMutation = { __typename?: 'Mutation', deleteOfferPrice: { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type CreateOfferPricesMutationVariables = Exact<{
  input: Array<CreateOfferPriceInput> | CreateOfferPriceInput;
}>;


export type CreateOfferPricesMutation = { __typename?: 'Mutation', createOfferPrices: { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'OfferPriceList', totalItems: number } };

export type PasswordResetMutationVariables = Exact<{
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
}>;


export type PasswordResetMutation = { __typename?: 'Mutation', resetPassword: { __typename: 'CurrentUser', id: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'NotVerifiedError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordResetTokenExpiredError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordResetTokenInvalidError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordValidationError', errorCode: ErrorCode, message: string, validationErrorMessage: string } };

export type RegisterMutationVariables = Exact<{
  input: B2BRegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', registerB2BCustomer: { __typename: 'InvalidVatError', errorCode: ErrorCode, message: string } | { __typename: 'MissingPasswordError', errorCode: ErrorCode, message: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordValidationError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type RemoveAllOrderLinesMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveAllOrderLinesMutation = { __typename?: 'Mutation', removeAllOrderLines: { __typename: 'Order', id: string } | { __typename: 'OrderInterceptorError' } | { __typename: 'OrderModificationError', message: string } };

export type RemoveAllOrderLinesAndStockMovementsMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveAllOrderLinesAndStockMovementsMutation = { __typename?: 'Mutation', removeAllOrderLinesAndStockMovements: { __typename: 'Order', id: string } | { __typename: 'OrderInterceptorError', errorCode: ErrorCode, message: string } | { __typename: 'OrderModificationError', errorCode: ErrorCode, message: string } };

export type RemoveCouponCodeMutationVariables = Exact<{
  couponCode: Scalars['String']['input'];
}>;


export type RemoveCouponCodeMutation = { __typename?: 'Mutation', removeCouponCode?: { __typename?: 'Order', id: string, code: string } | null };

export type RemoveFromWishlistMutationVariables = Exact<{
  itemIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  wishlistId: Scalars['ID']['input'];
}>;


export type RemoveFromWishlistMutation = { __typename?: 'Mutation', removeFromWishlist: { __typename?: 'Wishlist', id: string, name: string } };

export type RemoveItemFromOrderMutationVariables = Exact<{
  orderLineID: Scalars['ID']['input'];
}>;


export type RemoveItemFromOrderMutation = { __typename?: 'Mutation', removeOrderLine: { __typename?: 'Order', id: string } | { __typename?: 'OrderInterceptorError' } | { __typename?: 'OrderModificationError', errorCode: ErrorCode, message: string } };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', requestPasswordReset?: { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } | null };

export type SetActiveCompanyMutationVariables = Exact<{
  companyId: Scalars['ID']['input'];
}>;


export type SetActiveCompanyMutation = { __typename?: 'Mutation', setActiveCompany: { __typename?: 'Customer', id: string, firstName: string, lastName: string } | { __typename?: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename?: 'NotAllowedError', errorCode: ErrorCode, message: string } };

export type SetShippingAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type SetShippingAddressMutation = { __typename?: 'Mutation', setOrderShippingAddress: { __typename?: 'NoActiveOrderError', errorCode: ErrorCode, message: string } | { __typename?: 'Order', id: string, state: string, updatedAt: any, createdAt: any, total: any, totalWithTax: any, subTotal: any, subTotalWithTax: any, shipping: any, currencyCode: CurrencyCode, shippingWithTax: any, totalQuantity: number, lines: Array<{ __typename?: 'OrderLine', id: string, linePrice: any, discountedLinePrice: any, unitPrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', currencyCode: CurrencyCode, id: string, name: string, sku: string, price: any, assets: Array<{ __typename?: 'Asset', id: string, source: string }> } }> } };

export type SetBillingAddressMutationVariables = Exact<{
  input: CreateAddressInput;
}>;


export type SetBillingAddressMutation = { __typename?: 'Mutation', setOrderBillingAddress: { __typename?: 'NoActiveOrderError', errorCode: ErrorCode, message: string } | { __typename?: 'Order', id: string, state: string, updatedAt: any, createdAt: any, total: any, totalWithTax: any, subTotal: any, subTotalWithTax: any, shipping: any, currencyCode: CurrencyCode, shippingWithTax: any, totalQuantity: number, lines: Array<{ __typename?: 'OrderLine', id: string, linePrice: any, discountedLinePrice: any, unitPrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', currencyCode: CurrencyCode, id: string, name: string, sku: string, price: any, assets: Array<{ __typename?: 'Asset', id: string, source: string }> } }> } };

export type SetOrderCustomFieldsMutationVariables = Exact<{
  comment?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  commission?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetOrderCustomFieldsMutation = { __typename?: 'Mutation', setOrderCustomFields: { __typename?: 'NoActiveOrderError', errorCode: ErrorCode, message: string } | { __typename?: 'Order', id: string } };

export type SetOrderShippingMethodMutationVariables = Exact<{
  shippingMethodId: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SetOrderShippingMethodMutation = { __typename?: 'Mutation', setOrderShippingMethod: { __typename?: 'IneligibleShippingMethodError', errorCode: ErrorCode, message: string } | { __typename?: 'NoActiveOrderError', errorCode: ErrorCode, message: string } | { __typename?: 'Order', id: string, state: string, updatedAt: any, createdAt: any, total: any, totalWithTax: any, subTotal: any, subTotalWithTax: any, shipping: any, currencyCode: CurrencyCode, shippingWithTax: any, totalQuantity: number, lines: Array<{ __typename?: 'OrderLine', id: string, linePrice: any, discountedLinePrice: any, unitPrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', currencyCode: CurrencyCode, id: string, name: string, sku: string, price: any, assets: Array<{ __typename?: 'Asset', id: string, source: string }> } }> } | { __typename?: 'OrderModificationError', errorCode: ErrorCode, message: string } };

export type ToogleCustomerSpecificPriceMutationVariables = Exact<{ [key: string]: never; }>;


export type ToogleCustomerSpecificPriceMutation = { __typename?: 'Mutation', toggleCustomerSpecificPrices: { __typename?: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename?: 'Order', id: string, total: any, lines: Array<{ __typename?: 'OrderLine', quantity: number, unitPrice: any, productVariant: { __typename?: 'ProductVariant', price: any, id: string } }> } };

export type TransformOfferToCartMutationVariables = Exact<{
  offerId: Scalars['ID']['input'];
}>;


export type TransformOfferToCartMutation = { __typename?: 'Mutation', transformOfferToCart: { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type TransitionOrderMutationVariables = Exact<{
  state: Scalars['String']['input'];
}>;


export type TransitionOrderMutation = { __typename?: 'Mutation', transitionOrderToState?: { __typename?: 'Order', id: string, state: string, updatedAt: any, createdAt: any, total: any, totalWithTax: any, subTotal: any, subTotalWithTax: any, shipping: any, currencyCode: CurrencyCode, shippingWithTax: any, totalQuantity: number, lines: Array<{ __typename?: 'OrderLine', id: string, linePrice: any, discountedLinePrice: any, unitPrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', currencyCode: CurrencyCode, id: string, name: string, sku: string, price: any, assets: Array<{ __typename?: 'Asset', id: string, source: string }> } }> } | { __typename?: 'OrderStateTransitionError', errorCode: ErrorCode, message: string, transitionError: string, fromState: string, toState: string } | null };

export type UpdateCustomerMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  salutation?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer: { __typename?: 'Customer', id: string } };

export type UpdateCustomerPasswordMutationVariables = Exact<{
  currentPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type UpdateCustomerPasswordMutation = { __typename?: 'Mutation', updateCustomerPassword: { __typename: 'InvalidCredentialsError', errorCode: ErrorCode, message: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'PasswordValidationError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type RequestUpdateCustomerEmailMutationVariables = Exact<{
  password: Scalars['String']['input'];
  newEmailAddress: Scalars['String']['input'];
}>;


export type RequestUpdateCustomerEmailMutation = { __typename?: 'Mutation', requestUpdateCustomerEmailAddress: { __typename: 'EmailAddressConflictError', errorCode: ErrorCode, message: string } | { __typename: 'InvalidCredentialsError', errorCode: ErrorCode, message: string } | { __typename: 'NativeAuthStrategyError', errorCode: ErrorCode, message: string } | { __typename: 'Success', success: boolean } };

export type UpdateOfferMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  subject?: InputMaybe<Scalars['String']['input']>;
  headerText?: InputMaybe<Scalars['String']['input']>;
  footerText?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  positions?: InputMaybe<Array<CreateOfferPositionInput> | CreateOfferPositionInput>;
  termsOfDelivery?: InputMaybe<Scalars['String']['input']>;
  termsOfPayment?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  number?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OfferStatus>;
  additionalDiscount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateOfferMutation = { __typename?: 'Mutation', updateOffer: { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'NotAllowedError', errorCode: ErrorCode, message: string } | { __typename: 'Offer', id: string } };

export type UpdateOfferSettingsMutationVariables = Exact<{
  color?: InputMaybe<Scalars['String']['input']>;
  vat?: InputMaybe<Scalars['String']['input']>;
  iban?: InputMaybe<Scalars['String']['input']>;
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bankName?: InputMaybe<Scalars['String']['input']>;
  bankCode?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  companyRegister?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateOfferSettingsMutation = { __typename?: 'Mutation', updateOfferSettings: { __typename: 'EntityNotFoundError', errorCode: ErrorCode, message: string } | { __typename: 'OfferSettings', id: string } };

export type UpdateWishlistMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateWishlistMutation = { __typename?: 'Mutation', updateWishlist: { __typename?: 'Wishlist', id: string } };

export type ActiveChannelQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveChannelQuery = { __typename?: 'Query', activeChannel: { __typename?: 'Channel', id: string, code: string, currencyCode: CurrencyCode, pricesIncludeTax: boolean, token: string, defaultLanguageCode: LanguageCode, defaultShippingZone?: { __typename?: 'Zone', id: string, name: string, members: Array<{ __typename?: 'Country', id: string, name: string } | { __typename?: 'Province', id: string, name: string }> } | null } };

export type ActiveCompanyQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCompanyQuery = { __typename?: 'Query', activeCompany?: { __typename?: 'Company', id: string, name: string, customFields?: { __typename?: 'CompanyCustomFields', erpId?: string | null, vat?: string | null, ust?: string | null, isConfiguratorAdmin?: boolean | null } | null, termsOfPayment?: { __typename?: 'TermsOfPayment', paymentId?: string | null, contactPerson?: string | null, text?: string | null, amount?: number | null } | null, discounts?: Array<{ __typename?: 'CustomerDiscount', id: string, discountType?: string | null, discountGroup?: string | null, discountType2?: string | null, customFields?: { __typename?: 'CustomerDiscountCustomFields', erpId?: string | null } | null, customerDiscountPercentages?: Array<{ __typename?: 'CustomerDiscountPercentage', id: string, value?: number | null, index?: number | null } | null> | null } | null> | null } | null };

export type ActiveCompanyAddressesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCompanyAddressesQuery = { __typename?: 'Query', activeCompany?: { __typename?: 'Company', addresses: Array<{ __typename?: 'CompanyAddress', id: string, fullName: string, streetLine1: string, streetLine2?: string | null, province?: string | null, countryCode?: string | null, city?: string | null, postalCode?: string | null, phoneNumber?: string | null, defaultBillingAddress: boolean, defaultShippingAddress: boolean, customFields?: { __typename?: 'CompanyAddressCustomFields', erpId?: string | null } | null }> } | null };

export type ContactPersonIdQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactPersonIdQuery = { __typename?: 'Query', activeCompany?: { __typename?: 'Company', termsOfPayment?: { __typename?: 'TermsOfPayment', contactPerson?: string | null } | null } | null };

export type ActiveCustomerQueryVariables = Exact<{
  withCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ActiveCustomerQuery = { __typename?: 'Query', activeCustomer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string, emailAddress: string, title?: string | null, phoneNumber?: string | null, customFields?: { __typename?: 'CustomerCustomFields', salutation?: string | null } | null } | null };

export type ActiveCustomerRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCustomerRolesQuery = { __typename?: 'Query', activeCustomer?: { __typename?: 'Customer', groups: Array<{ __typename?: 'CustomerGroup', id: string, name: string }>, customFields?: { __typename?: 'CustomerCustomFields', useCSP?: boolean | null } | null } | null };

export type ActiveCustomerForCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCustomerForCheckoutQuery = { __typename?: 'Query', activeCustomer?: { __typename?: 'Customer', firstName: string, lastName: string, addresses?: Array<{ __typename?: 'Address', id: string, createdAt: any, updatedAt: any, fullName?: string | null, streetLine1: string, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, customFields?: any | null, country: { __typename?: 'Country', id: string, languageCode: LanguageCode, code: string, name: string, enabled: boolean, customFields?: any | null } }> | null } | null };

export type ActiveCustomerOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveCustomerOrdersQuery = { __typename?: 'Query', activeCustomer?: { __typename?: 'Customer', orders: { __typename?: 'OrderList', items: Array<{ __typename?: 'Order', id: string, code: string, state: string, total: any, currencyCode: CurrencyCode, orderPlacedAt?: any | null, customFields?: { __typename?: 'OrderCustomFields', erpId?: string | null } | null }> } } | null };

export type ActiveOrderCartQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrderCartQuery = { __typename?: 'Query', activeOrder?: { __typename?: 'Order', state: string, subTotal: any, shipping: any, total: any, totalWithTax: any, currencyCode: CurrencyCode, subTotalWithTax: any, shippingWithTax: any, totalQuantity: number, couponCodes: Array<string>, promotions: Array<{ __typename?: 'Promotion', id: string, name: string, couponCode?: string | null }>, discounts: Array<{ __typename?: 'Discount', amount: any, description: string }>, taxSummary: Array<{ __typename?: 'OrderTaxSummary', taxRate: number, taxBase: any, taxTotal: any }>, lines: Array<{ __typename?: 'OrderLine', id: string, discountedLinePrice: any, unitPrice: any, linePrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', id: string, currencyCode: CurrencyCode, price: any, name: string, sku: string, assets: Array<{ __typename?: 'Asset', source: string }>, facetValues: Array<{ __typename?: 'FacetValue', id: string, name: string, facet: { __typename?: 'Facet', name: string } }>, options: Array<{ __typename?: 'ProductOption', code: string, group: { __typename?: 'ProductOptionGroup', name: string } }>, product: { __typename?: 'Product', name: string, slug: string }, customFields?: { __typename?: 'ProductVariantCustomFields', systemName?: string | null } | null } }>, customer?: { __typename?: 'Customer', id: string, customFields?: { __typename?: 'CustomerCustomFields', erpId?: string | null, company?: { __typename?: 'Company', customFields?: { __typename?: 'CompanyCustomFields', erpId?: string | null } | null } | null } | null } | null } | null };

export type ActiveOrderCheckoutQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrderCheckoutQuery = { __typename?: 'Query', activeOrder?: { __typename?: 'Order', id: string, state: string, updatedAt: any, createdAt: any, total: any, totalWithTax: any, subTotal: any, subTotalWithTax: any, shipping: any, currencyCode: CurrencyCode, shippingWithTax: any, totalQuantity: number, couponCodes: Array<string>, promotions: Array<{ __typename?: 'Promotion', id: string, name: string, couponCode?: string | null }>, discounts: Array<{ __typename?: 'Discount', amount: any, description: string }>, taxSummary: Array<{ __typename?: 'OrderTaxSummary', taxRate: number, taxBase: any, taxTotal: any }>, shippingAddress?: { __typename?: 'OrderAddress', fullName?: string | null, company?: string | null, streetLine1?: string | null, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null, phoneNumber?: string | null, customFields?: any | null } | null, billingAddress?: { __typename?: 'OrderAddress', fullName?: string | null, company?: string | null, streetLine1?: string | null, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null, phoneNumber?: string | null, customFields?: any | null } | null, shippingLines: Array<{ __typename?: 'ShippingLine', shippingMethod: { __typename?: 'ShippingMethod', id: string, languageCode: LanguageCode, code: string, name: string, description: string } }>, lines: Array<{ __typename?: 'OrderLine', id: string, linePrice: any, discountedLinePrice: any, unitPrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', currencyCode: CurrencyCode, id: string, name: string, sku: string, price: any, product: { __typename?: 'Product', id: string, name: string, slug: string }, facetValues: Array<{ __typename?: 'FacetValue', id: string, name: string, facet: { __typename?: 'Facet', name: string } }>, assets: Array<{ __typename?: 'Asset', id: string, source: string }> } }> } | null };

export type ActiveOrderNavigationQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrderNavigationQuery = { __typename?: 'Query', activeOrder?: { __typename?: 'Order', lines: Array<{ __typename?: 'OrderLine', quantity: number }> } | null };

export type ActiveOrderOfferQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveOrderOfferQuery = { __typename?: 'Query', activeOrder?: { __typename?: 'Order', id: string } | null };

export type ActiveUserWishlistQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ActiveUserWishlistQuery = { __typename?: 'Query', activeUserWishlist?: { __typename?: 'Wishlist', id: string, itemCount: number, name: string, createdAt: any, description?: string | null, isPublic: boolean, publicCode?: string | null, items: Array<{ __typename?: 'WishlistItem', id: string, purchased: boolean, lastPurchasedAt?: any | null, product: { __typename?: 'Product', id: string, name: string, slug: string, featuredAsset?: { __typename?: 'Asset', source: string } | null }, productVariant: { __typename?: 'ProductVariant', id: string, sku: string, name: string, price: any, priceWithTax: any, stockLevel: string, customFields?: { __typename?: 'ProductVariantCustomFields', systemName?: string | null } | null } }> } | null };

export type ActiveUserWishlistsQueryVariables = Exact<{ [key: string]: never; }>;


export type ActiveUserWishlistsQuery = { __typename?: 'Query', activeUserWishlists: Array<{ __typename?: 'Wishlist', id: string, itemCount: number, name: string, createdAt: any, description?: string | null, isPublic: boolean, publicCode?: string | null, items: Array<{ __typename?: 'WishlistItem', id: string, purchased: boolean, lastPurchasedAt?: any | null, product: { __typename?: 'Product', id: string, name: string, slug: string }, productVariant: { __typename?: 'ProductVariant', id: string, sku: string, name: string, price: any, priceWithTax: any, stockLevel: string } }> }> };

export type AllCollectionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCollectionsQuery = { __typename?: 'Query', collections: { __typename?: 'CollectionList', items: Array<{ __typename?: 'Collection', slug: string, breadcrumbs: Array<{ __typename?: 'CollectionBreadcrumb', name: string, id: string, slug: string }> }> } };

export type AvailableCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCompaniesQuery = { __typename?: 'Query', companies?: { __typename?: 'CompanyList', items: Array<{ __typename?: 'Company', id: string, name: string, customFields?: { __typename?: 'CompanyCustomFields', erpId?: string | null, vat?: string | null, ust?: string | null } | null, addresses: Array<{ __typename?: 'CompanyAddress', fullName: string, streetLine1: string }> }> } | null };

export type AvailableCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AvailableCountriesQuery = { __typename?: 'Query', availableCountries: Array<{ __typename?: 'Country', id: string, languageCode: LanguageCode, code: string, name: string, enabled: boolean, customFields?: any | null }> };

export type CollectionQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
}>;


export type CollectionQuery = { __typename?: 'Query', collection?: { __typename?: 'Collection', id: string, slug: string, name: string, description: string, customFields?: { __typename?: 'CollectionCustomFields', seoDescription?: string | null, hasDetailPage?: boolean | null, preselectedDiameter?: number | null } | null, breadcrumbs: Array<{ __typename?: 'CollectionBreadcrumb', name: string, id: string, slug: string }>, assets: Array<{ __typename?: 'Asset', width: number, height: number, source: string }> } | null };

export type CustomerSpecificPriceQueryVariables = Exact<{
  channelCode: Scalars['String']['input'];
  variantId: Scalars['String']['input'];
}>;


export type CustomerSpecificPriceQuery = { __typename?: 'Query', customerSpecificPrice?: { __typename?: 'CustomerSpecificPrice', basePrice: number, price: number } | null };

export type EligiblePaymentMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type EligiblePaymentMethodsQuery = { __typename?: 'Query', eligiblePaymentMethods: Array<{ __typename?: 'PaymentMethodQuote', id: string, code: string, name: string, description: string, isEligible: boolean, eligibilityMessage?: string | null, customFields?: any | null }> };

export type EligibleShippingMethodsQueryVariables = Exact<{ [key: string]: never; }>;


export type EligibleShippingMethodsQuery = { __typename?: 'Query', eligibleShippingMethods: Array<{ __typename?: 'ShippingMethodQuote', id: string, price: any, priceWithTax: any, code: string, name: string, description: string, metadata?: any | null, customFields?: any | null }> };

export type NextOrderStatesQueryVariables = Exact<{ [key: string]: never; }>;


export type NextOrderStatesQuery = { __typename?: 'Query', nextOrderStates: Array<string> };

export type OfferByIdQueryVariables = Exact<{
  offerId: Scalars['ID']['input'];
}>;


export type OfferByIdQuery = { __typename?: 'Query', offerById?: { __typename?: 'Offer', id: string, number: string, date: any, address: string, subject: string, headerText: string, footerText: string, termsOfDelivery: string, termsOfPayment: string, reference: string, status: OfferStatus, additionalDiscount?: number | null, customOfferLines?: Array<{ __typename?: 'OfferOrderLine', id: string, name: string, price: number, quantity: number, taxRate: number, discount: number, positionTotal: number, alternative: boolean, productVariant?: { __typename?: 'ProductVariant', price: any } | null }> | null, company: { __typename?: 'Company', id: string, name: string, customFields?: { __typename?: 'CompanyCustomFields', erpId?: string | null, vat?: string | null, ust?: string | null } | null, addresses: Array<{ __typename?: 'CompanyAddress', streetLine1: string, streetLine2?: string | null, province?: string | null, countryCode?: string | null, city?: string | null, postalCode?: string | null, phoneNumber?: string | null, defaultBillingAddress: boolean }> }, order: { __typename?: 'Order', id: string, totalWithTax: any, lines: Array<{ __typename?: 'OrderLine', id: string, customFields?: { __typename?: 'OrderLineCustomFields', offerOrderLine?: { __typename?: 'OfferOrderLine', id: string, price: number, quantity: number, taxRate: number, discount: number, name: string, alternative: boolean, positionTotal: number, productVariant?: { __typename?: 'ProductVariant', id: string, price: any, sku: string, product: { __typename?: 'Product', description: string }, options: Array<{ __typename?: 'ProductOption', id: string, name: string, code: string, group: { __typename?: 'ProductOptionGroup', name: string } }> } | null } | null } | null }> } } | null };

export type OfferPositionVariantsQueryVariables = Exact<{
  skus: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type OfferPositionVariantsQuery = { __typename?: 'Query', variants: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku: string, price: any, options: Array<{ __typename?: 'ProductOption', id: string, code: string, name: string, group: { __typename?: 'ProductOptionGroup', name: string } }> }> };

export type OfferPriceQueryVariables = Exact<{
  productVariantId: Scalars['ID']['input'];
}>;


export type OfferPriceQuery = { __typename?: 'Query', offerPrices?: { __typename?: 'OfferPriceList', items: Array<{ __typename?: 'OfferPrice', id: string, price: number, currencyCode: CurrencyCode }> } | null };

export type OfferPricesQueryVariables = Exact<{
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OfferPricesQuery = { __typename?: 'Query', offerPrices?: { __typename?: 'OfferPriceList', totalItems: number, items: Array<{ __typename?: 'OfferPrice', id: string, price: number, currencyCode: CurrencyCode, productVariant: { __typename?: 'ProductVariant', name: string, price: any, id: string, sku: string, product: { __typename?: 'Product', name: string }, featuredAsset?: { __typename?: 'Asset', width: number, height: number, source: string } | null, customFields?: { __typename?: 'ProductVariantCustomFields', systemName?: string | null } | null } }> } | null };

export type OfferPriceFragment = { __typename?: 'OfferPrice', id: string, price: number, currencyCode: CurrencyCode, productVariant: { __typename?: 'ProductVariant', name: string, price: any, id: string, sku: string, product: { __typename?: 'Product', name: string }, featuredAsset?: { __typename?: 'Asset', width: number, height: number, source: string } | null, customFields?: { __typename?: 'ProductVariantCustomFields', systemName?: string | null } | null } };

export type OfferSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type OfferSettingsQuery = { __typename?: 'Query', offerSettings?: { __typename?: 'OfferSettings', id: string, logo?: string | null, color?: string | null, vat?: string | null, iban?: string | null, accountNumber?: string | null, bankName?: string | null, bankCode?: string | null, address?: string | null, phoneNumber?: string | null, email?: string | null, companyRegister?: string | null } | null };

export type LatestOfferQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestOfferQuery = { __typename?: 'Query', offers?: Array<{ __typename?: 'Offer', id: string, reference: string, status: OfferStatus, createdAt: any, number: string, date: any, address: string, subject: string, headerText: string, footerText: string, termsOfDelivery: string, termsOfPayment: string, order: { __typename?: 'Order', lines: Array<{ __typename?: 'OrderLine', customFields?: { __typename?: 'OrderLineCustomFields', offerOrderLine?: { __typename?: 'OfferOrderLine', id: string } | null } | null }> } }> | null };

export type OffersQueryVariables = Exact<{
  filter?: InputMaybe<OfferFilterOptions>;
  sort?: InputMaybe<OfferSortOptions>;
  take?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OffersQuery = { __typename?: 'Query', offers?: Array<{ __typename?: 'Offer', id: string, reference: string, status: OfferStatus, createdAt: any, number: string, date: any, address: string, subject: string, headerText: string, footerText: string, termsOfDelivery: string, termsOfPayment: string, additionalDiscount?: number | null, customOfferLines?: Array<{ __typename?: 'OfferOrderLine', id: string, name: string, price: number, quantity: number, taxRate: number, discount: number, positionTotal: number, alternative: boolean }> | null, order: { __typename?: 'Order', id: string, totalWithTax: any, total: any, subTotal: any, subTotalWithTax: any, lines: Array<{ __typename?: 'OrderLine', customFields?: { __typename?: 'OrderLineCustomFields', offerOrderLine?: { __typename?: 'OfferOrderLine', price: number, positionTotal: number } | null } | null }> } }> | null };

export type OfferFragmentFragment = { __typename?: 'Offer', id: string, reference: string, status: OfferStatus, createdAt: any, number: string, date: any, address: string, subject: string, headerText: string, footerText: string, termsOfDelivery: string, termsOfPayment: string, additionalDiscount?: number | null, customOfferLines?: Array<{ __typename?: 'OfferOrderLine', id: string, name: string, price: number, quantity: number, taxRate: number, discount: number, positionTotal: number, alternative: boolean }> | null, order: { __typename?: 'Order', id: string, totalWithTax: any, total: any, subTotal: any, subTotalWithTax: any, lines: Array<{ __typename?: 'OrderLine', customFields?: { __typename?: 'OrderLineCustomFields', offerOrderLine?: { __typename?: 'OfferOrderLine', price: number, positionTotal: number } | null } | null }> } };

export type OrderQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type OrderQuery = { __typename?: 'Query', orderByCode?: { __typename?: 'Order', id: string, code: string, state: string, active: boolean, currencyCode: CurrencyCode, shipping: any, customer?: { __typename?: 'Customer', id: string, firstName: string, lastName: string, phoneNumber?: string | null } | null, shippingAddress?: { __typename?: 'OrderAddress', fullName?: string | null, company?: string | null, streetLine1?: string | null, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null, phoneNumber?: string | null, customFields?: any | null } | null, billingAddress?: { __typename?: 'OrderAddress', fullName?: string | null, company?: string | null, streetLine1?: string | null, streetLine2?: string | null, city?: string | null, province?: string | null, postalCode?: string | null, country?: string | null, countryCode?: string | null, phoneNumber?: string | null, customFields?: any | null } | null, shippingLines: Array<{ __typename?: 'ShippingLine', shippingMethod: { __typename?: 'ShippingMethod', id: string, languageCode: LanguageCode, code: string, name: string, description: string } }>, lines: Array<{ __typename?: 'OrderLine', id: string, linePrice: any, discountedLinePrice: any, unitPrice: any, quantity: number, productVariant: { __typename?: 'ProductVariant', currencyCode: CurrencyCode, id: string, name: string, sku: string, price: any, product: { __typename?: 'Product', id: string, name: string, slug: string }, assets: Array<{ __typename?: 'Asset', id: string, source: string }>, customFields?: { __typename?: 'ProductVariantCustomFields', systemName?: string | null } | null } }>, payments?: Array<{ __typename?: 'Payment', method: string }> | null } | null };

export type PriceQueryVariables = Exact<{
  variantId: Scalars['Int']['input'];
}>;


export type PriceQuery = { __typename?: 'Query', pimcoreObjects: { __typename?: 'PimcoreObjectsResult', productVariants?: Array<{ __typename?: 'ProductVariant', price: any } | null> | null } };

export type ProductQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']['input']>;
  withCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  isPreRender?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ProductQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, slug: string, name: string, description: string, customFields?: { __typename?: 'ProductCustomFields', productDetailName?: string | null, infoText?: string | null, pimcoreId?: number | null, downloads?: Array<{ __typename?: 'Download', id: string, fileName: string, fileSize?: number | null, path: string }> | null } | null, assets: Array<{ __typename?: 'Asset', width: number, height: number, source: string }>, collections: Array<{ __typename?: 'Collection', id: string, customFields?: { __typename?: 'CollectionCustomFields', preselectedDiameter?: number | null } | null, breadcrumbs: Array<{ __typename?: 'CollectionBreadcrumb', name: string, id: string, slug: string }> }>, variants: Array<{ __typename?: 'ProductVariant', id: string, name: string, sku: string, stockLevel: string, currencyCode: CurrencyCode, price: any, options: Array<{ __typename?: 'ProductOption', code: string, group: { __typename?: 'ProductOptionGroup', name: string } }>, facetValues: Array<{ __typename?: 'FacetValue', id: string, code: string, name: string }>, customFields?: { __typename?: 'ProductVariantCustomFields', pimcoreId?: number | null, productDetailName?: string | null, infoText?: string | null, systemName?: string | null, customAttributes?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, onSiteImages?: Array<{ __typename?: 'Asset', name: string, source: string }> | null, systemInformationItems?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, additionalProducts?: Array<{ __typename?: 'Product', id: string, name: string }> | null } | null, assets: Array<{ __typename?: 'Asset', width: number, height: number, source: string }> }> } | null };

export type ProductsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductList', items: Array<{ __typename?: 'Product', slug: string, variants: Array<{ __typename?: 'ProductVariant', id: string }> }> } };

export type SearchQueryVariables = Exact<{
  input: Scalars['String']['input'];
  prefixMode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'SearchResponse', items: Array<{ __typename?: 'SearchResult', id: string, sku: string, slug: string, productId: string, productName: string, productVariantId: string, productVariantName: string, description: string, price: { __typename?: 'PriceRange' } | { __typename?: 'SinglePrice', value: any }, productVariantAsset?: { __typename?: 'SearchResultAsset', preview: string } | null, customMappings: { __typename?: 'SearchResultCustomMappings', systemLine?: string | null, systemName?: string | null } }> } };

export type VariantQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  withCustomFields?: InputMaybe<Scalars['Boolean']['input']>;
  isPreRender?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VariantQuery = { __typename?: 'Query', variant?: { __typename?: 'ProductVariant', id: string, name: string, sku: string, stockLevel: string, currencyCode: CurrencyCode, price: any, options: Array<{ __typename?: 'ProductOption', code: string, group: { __typename?: 'ProductOptionGroup', name: string } }>, facetValues: Array<{ __typename?: 'FacetValue', id: string, code: string, name: string }>, customFields?: { __typename?: 'ProductVariantCustomFields', pimcoreId?: number | null, productDetailName?: string | null, infoText?: string | null, systemName?: string | null, customAttributes?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, onSiteImages?: Array<{ __typename?: 'Asset', name: string, source: string }> | null, systemInformationItems?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, additionalProducts?: Array<{ __typename?: 'Product', id: string, name: string }> | null } | null, assets: Array<{ __typename?: 'Asset', width: number, height: number, source: string }> } | null };

export type VariantAdditionalProductsQueryVariables = Exact<{
  variantId: Scalars['ID']['input'];
}>;


export type VariantAdditionalProductsQuery = { __typename?: 'Query', variantAdditionalProducts: Array<{ __typename?: 'Product', id: string, slug: string, name: string, featuredAsset?: { __typename?: 'Asset', source: string } | null, customFields?: { __typename?: 'ProductCustomFields', systemName?: string | null } | null }> };

export type VariantDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  includeImages?: InputMaybe<Scalars['Boolean']['input']>;
  includeSystemInformation?: InputMaybe<Scalars['Boolean']['input']>;
  includeDownloads?: InputMaybe<Scalars['Boolean']['input']>;
  includeAdditionalProducts?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type VariantDetailsQuery = { __typename?: 'Query', variant?: { __typename?: 'ProductVariant', customFields?: { __typename?: 'ProductVariantCustomFields', onSiteImages?: Array<{ __typename?: 'Asset', name: string, source: string }> | null, systemInformationItems?: Array<{ __typename?: 'Block', itemText?: string | null, itemHeadline?: string | null }> | null, downloads?: Array<{ __typename?: 'Download', id: string, fileName: string, fileSize?: number | null, path: string }> | null, additionalProducts?: Array<{ __typename?: 'Product', id: string, slug: string, name: string, featuredAsset?: { __typename?: 'Asset', source: string } | null, customFields?: { __typename?: 'ProductCustomFields', systemName?: string | null } | null }> | null } | null } | null };

export type VariantVendureIdQueryVariables = Exact<{
  variantId: Scalars['Int']['input'];
}>;


export type VariantVendureIdQuery = { __typename?: 'Query', pimcoreObjects: { __typename?: 'PimcoreObjectsResult', productVariants?: Array<{ __typename?: 'ProductVariant', id: string } | null> | null } };
